import { useEffect, useRef, useState } from "react";
import { Camera, Check, Clock3, Instagram, MapPin, Sparkles, Video, Zap } from "lucide-react";
import { BrowserRouter, Link, Route, Routes, useLocation, useNavigate, useParams } from "react-router-dom";
import "@/App.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const SAME_SITE_API = "/api";
const pricingGraphic = "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/51jiatra_DM%20TO%20BOOK%21.png";
const logoUrl = "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/xyfsw92h_ChatGPT%20Image%20Jun%207%2C%202026%2C%2009_19_18%20AM.png";
const instagramUrl = "https://www.instagram.com/digiuseppimedia/";
const businessCardUrl = "https://dot.cards/digiuseppimedia";
const photoPortfolioUrl = "https://mvdigiuseppi4714.myportfolio.com/work";
const mediaPortfolioUrl = "https://mvdigiuseppi0666.myportfolio.com/portfolio";
const videoSamples = [
  "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/fbdozjmb_Project%20Name%204.MOV",
  "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/j54zgarw_Sequence%2002%20%281%29.mp4",
];

const videoHighlights = [
  { title: "Project Name 4", caption: "Wheatley 8th Grade Boys Basketball", src: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/h5cmbjfc_Project%20Name%204.MOV" },
  { title: "Anron Website Video", caption: "Anron Air Systems Website Video", src: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/yqhtqqjr_Final%20Anron%20website%20video%20All%20revisionsmp4.mp4" },
  { title: "Milana Outing 2026", caption: "Milana Family Foundation 2026 Annual Golf Outing", src: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/ucx54bps_Milana%20Outing%202026%20%20%281%29.mp4" },
  { title: "LIB Hype Reel", caption: "Long Island Baseball 12u", src: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/qx3nb5lk_LIB%20Hype%20Reel%20%282%29.mp4" },
];

const graphicShowcase = [
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/log0jc8p_Riley%20Longhorns%20G1.png",
    title: "Riley Longhorns Graphic",
    tag: "CUSTOM GRAPHIC",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/wbir24an_Untitled-3.png",
    title: "Chaminade Baseball Christian Calabro Graphic",
    tag: "CUSTOM GRAPHIC",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/mgn1oqql__34A4231.webp",
    title: "Chaminade High School Sebastian Logiudice Graphic",
    tag: "CUSTOM GRAPHIC",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/ugtgv105_1.png",
    title: "Stranger Things Basketball Graphic",
    tag: "CUSTOM GRAPHIC",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/53or17c4_1.png",
    title: "Shortstop Player Card Graphic",
    tag: "CUSTOM GRAPHIC",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/x9ir4a8e_2.png",
    title: "Leo Pitching Orange Graphic",
    tag: "ATHLETE EDIT",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/j1hwxfak_2.png",
    title: "Stranger Things Sideline Graphic",
    tag: "POSTER STYLE",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/i8w0irn1_1.png",
    title: "Luca Red Poster Graphic",
    tag: "CUSTOM GRAPHIC",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/ufp8mlsx_3.png",
    title: "Leo Windup Orange Graphic",
    tag: "CUSTOM GRAPHIC",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/6jwclofi_3.png",
    title: "Stranger Things Portrait Graphic",
    tag: "CUSTOM GRAPHIC",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/o7q27pno_2.png",
    title: "Catcher Player Card Graphic",
    tag: "CUSTOM GRAPHIC",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/kfg5dyws_1.png",
    title: "Luca Baseball Hero Graphic",
    tag: "CUSTOM GRAPHIC",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/0rfkxc3m_4.png",
    title: "Tyler Orange Graphic",
    tag: "CUSTOM GRAPHIC",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/eqcw4i4s_2.png",
    title: "Leo Red Poster Graphic",
    tag: "CUSTOM GRAPHIC",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/ev3y47ky_5.png",
    title: "Ryan Orange Graphic",
    tag: "CUSTOM GRAPHIC",
  },
];

const realPhotos = [
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/nb1xj3kb_IMG_1732.JPG",
    title: "Sky High Catch",
    tag: "BASEBALL",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/4etccmfe_IMG_1731.JPG",
    title: "Mound Follow Through",
    tag: "BASEBALL",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/lei53hco_IMG_1733.JPG",
    title: "Red Helmet Focus",
    tag: "BASEBALL",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/m07ouhf3__34A7436.webp",
    title: "Golf Green Moment",
    tag: "BASEBALL",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/j7l8iass_58-_34A5024.webp",
    title: "Youth Baseball Catch",
    tag: "BASEBALL",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/23sz7j6x_57-_34A6777.webp",
    title: "Baseball On Deck",
    tag: "GOLF",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/upaxc3pf_IMG_0771.jpeg",
    title: "Baseball Batter Framed Through Dugout",
    tag: "BASEBALL ACTION",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/bq5o00ft_IMG_0772.jpeg",
    title: "Pitcher Locked In",
    tag: "GAME MOMENT",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/5sr23jth_IMG_0773.jpeg",
    title: "Rinkside Hockey Portrait",
    tag: "HOCKEY DETAIL",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/cfv3g6bo_IMG_0774.jpeg",
    title: "Islanders Ice Moment",
    tag: "HOCKEY ACTION",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/trmilmah_IMG_0775.jpeg",
    title: "Full Swing Baseball Finish",
    tag: "PHOTO FINISH",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/hu36tr66_IMG_0780.jpeg",
    title: "Basketball Handle Detail",
    tag: "BASKETBALL",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/jramikwc_IMG_0779.jpeg",
    title: "Black and White Pitcher",
    tag: "BASEBALL",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/8p02ekz5_IMG_0778.jpeg",
    title: "Mound Portrait",
    tag: "BASEBALL",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/3l1eg0aq_IMG_0777.jpeg",
    title: "Red Helmet Dugout Moment",
    tag: "BASEBALL",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bold-highlights/artifacts/s45a19gm_IMG_0776.jpeg",
    title: "On Deck Batter",
    tag: "BASEBALL",
  },
];

const heroImage = realPhotos[0].src;
const photoAthlete = realPhotos[10].src;
const videoAthlete = realPhotos[8].src;

const photoPackages = [
  {
    id: "single-player-photography",
    label: "Single Player",
    price: "$50",
    meta: "Per Game",
    bullets: ["40–45 edited photos", "2 graphics", "Private download link"],
  },
  {
    id: "team-photography",
    label: "Team Package",
    price: "$300",
    meta: "For 2 Games",
    bullets: ["6–8 photos per player", "1 graphic design per player", "Private download link", "$200 for 1 additional game"],
  },
];

const videoPackages = [
  {
    id: "single-player-videography",
    label: "Single Player",
    price: "$75",
    meta: "Per Game",
    bullets: ["All videos taken", "Fully edited hype reel / mixtape", "Private download link"],
  },
  {
    id: "team-videography",
    label: "Team Package",
    price: "$450",
    meta: "For 2 Games",
    bullets: ["2 of the following: mixtape, hype reel, or custom team edit", "Private download link", "$250 for 1 additional game"],
  },
];

const mediaDayPackage = {
  id: "media-day",
  label: "Media Day",
  price: "$100",
  meta: "Per Athlete · 5 Athlete Min",
  bullets: ["8–10 edited photos per athlete", "2 headshots + 6–8 action/body shots", "Full team session (~2.5 hours)", "Proofs delivered"],
};

const packageDetails = {
  "single-player-photography": {
    ...photoPackages[0],
    type: "Photography",
    tone: "photo",
    headline: "Single Player Photography",
    description: "Built for individual athletes who want sharp, high-energy images from one game. This package captures the moments that matter most: action, emotion, intensity, and clean social-ready edits that help you stand out.",
    idealFor: ["Athletes building a recruiting profile", "Players who want game-day content", "Families who want clean keepsake images"],
    deliverables: ["40–45 edited photos", "2 custom graphics", "Private download link", "Fast 24–72 hour turnaround when possible"],
    photos: [realPhotos[8], realPhotos[10], realPhotos[12], realPhotos[3]],
  },
  "team-photography": {
    ...photoPackages[1],
    type: "Photography",
    tone: "photo",
    headline: "Team Photography Package",
    description: "Designed for teams that want coverage across multiple players and moments. This package gives athletes, families, and coaches a full set of clean edits that capture the team’s energy across two games.",
    idealFor: ["Youth teams and school teams", "Roster-wide content", "Coaches who want content for the whole group"],
    deliverables: ["6–8 photos per player", "1 graphic design per player", "Private download link", "$200 for 1 additional game"],
    photos: [realPhotos[4], realPhotos[9], realPhotos[11], realPhotos[7]],
  },
  "single-player-videography": {
    ...videoPackages[0],
    type: "Videography",
    tone: "video",
    headline: "Single Player Videography",
    description: "Made for athletes who want motion, pace, and energy. This package captures clips from the game and turns them into an edited hype reel or mixtape that is ready to post, share, and use for exposure.",
    idealFor: ["Individual player mixtapes", "Social media highlight reels", "Recruiting-style clips"],
    deliverables: ["All videos taken", "Fully edited hype reel / mixtape", "Private download link", "Vertical-friendly edit for social posting"],
    videos: videoSamples,
  },
  "team-videography": {
    ...videoPackages[1],
    type: "Videography",
    tone: "video",
    headline: "Team Videography Package",
    description: "Built for teams that want cinematic coverage and a polished team edit. Choose from mixtape, hype reel, or a custom team edit to capture the biggest plays, celebrations, and momentum moments.",
    idealFor: ["Team hype reels", "Season recap content", "Program promotion and social media"],
    deliverables: ["2 edits: mixtape, hype reel, or custom team edit", "Private download link", "$250 for 1 additional game", "Includes full-energy cinematic pacing"],
    videos: videoSamples,
  },
  "media-day": {
    ...mediaDayPackage,
    type: "Photography",
    tone: "photo",
    headline: "Media Day",
    description: "A full team media day session built to make every athlete look professional. In one session of about 2.5 hours, each athlete gets posed headshots plus high-energy action and body shots — perfect for rosters, recruiting profiles, banners, and social content.",
    idealFor: ["Teams that want roster-wide content in one session", "Schools, clubs, and travel programs", "Coaches who want pro headshots and action shots for every athlete"],
    deliverables: ["8–10 edited photos per athlete", "2 headshots per athlete", "6–8 action/body/other shots per athlete", "Full team session (about 2.5 hours)", "Proofs delivered for review", "Private download link"],
    terms: "$100 per athlete with a 5 athlete minimum. Half is due up front as a deposit to lock in your date, and the other half is paid after the session. Proofs are delivered for your team to review.",
    bookingLink: "/media-day-booking",
    detailClass: "media-day-detail",
    stats: [
      { value: "$100", label: "Per Athlete" },
      { value: "5+", label: "Athlete Minimum" },
      { value: "~2.5", label: "Hour Team Session" },
      { value: "8–10", label: "Photos Per Athlete" },
    ],
  },
};

const features = [
  { icon: Clock3, title: "24–72 Hour Delivery", detail: "Get your photos and videos quickly." },
  { icon: Sparkles, title: "Built for Athletes", detail: "Content designed for Instagram, recruiting, team pages and memories." },
  { icon: Camera, title: "Professional Equipment", detail: "Professional Canon photography and cinematic video production." },
  { icon: MapPin, title: "Long Island Based", detail: "Serving Nassau, Suffolk and surrounding areas." },
];

const faqs = [
  {
    question: "How far in advance should I book?",
    answer: "Book at least 24 hours in advance when possible. Spots are limited each week, so earlier is always better if you want to lock in a game or team shoot.",
  },
  {
    question: "How fast will I get my photos or video?",
    answer: "Most projects are delivered within 24–72 hours depending on the package, game schedule, and editing workload.",
  },
  {
    question: "How do I receive my files?",
    answer: "Final photos and videos are sent through a private download link, making it easy to save, share, and post your content.",
  },
  {
    question: "Can you cover teams and individual athletes?",
    answer: "Yes. Single player packages are built for individual athletes, while team packages cover multiple players and deliver content for the full group.",
  },
  {
    question: "What sports do you shoot?",
    answer: "Baseball, basketball, hockey, football, soccer, volleyball, and more. If there’s action, emotion, and a story to capture, it can be covered.",
  },
  {
    question: "Are there travel fees?",
    answer: "Jobs on Long Island only. No additional charge for jobs in Nassau and Suffolk County. However, jobs out of Nassau and Suffolk have a $20 up-charge.",
  },
  {
    question: "How do I book?",
    answer: "Click any BOOK NOW button, fill out the booking form with your sport, date, and package, and Michael will follow up to confirm details.",
  },
];

const magazinePackages = [
  {
    title: "Athlete Mini Magazine",
    pages: "12–16 pages",
    bestFor: "Best for individual athletes",
    includes: ["Custom cover", "Athlete profile", "Best action photos", "Season highlights", "Stats page", "Awards page", "Photographer page"],
  },
  {
    title: "Athlete Premium Magazine",
    pages: "24–32 pages",
    bestFor: "Main premium product",
    includes: ["Everything in Mini", "More photo spreads", "Athlete story", "Behind-the-scenes section", "Career highlights", "Favorite moments", "Recruiting section", "QR code linking to highlight video"],
  },
  {
    title: "Elite Legacy Magazine",
    pages: "40–60 pages",
    bestFor: "Luxury individual version",
    includes: ["Everything in Premium", "Full season documentary style", "Team section", "Coach quotes", "Family thank-you page", "Timeline of career", "Multiple interviews", "Championship/playoff section", "Premium photo spreads"],
  },
  {
    title: "Team Season Magazine",
    pages: "40–100+ pages",
    bestFor: "For entire teams",
    includes: ["Team cover", "Coaches page", "Full roster pages", "Player profiles", "Schedule/results", "Season recap", "Awards", "Senior section", "Championship section"],
  },
];

const magazineTemplateGroups = [
  { title: "Cover Options", items: ["Full-page hero action photo", "Split photo layout with stats overlay", "Magazine-style cover with headlines"] },
  { title: "Athlete Profiles", items: ["Player card style", "Magazine profile", "Recruiting profile with QR code"] },
  { title: "Photo Spreads", items: ["Full-page cinematic photo", "Two-page action spread", "Collage layout", "Film strip layout", "Before/after sequence", "Game timeline layout"] },
  { title: "Feature Pages", items: ["Season timeline", "Awards page", "Senior tribute", "Coach/parent message", "Behind-the-scenes", "Recruiting page", "Thank-you page"] },
];

const businessPackages = [
  {
    name: "Bronze",
    price: "$500",
    deposit: "$200",
    annual: "+ $100/year for website after first year — first year free",
    tagline: "A simple, professional start.",
    description: "Perfect for small businesses or anyone who needs clean, high-quality content without overcomplicating things. This package gives you a strong visual presence and gets your brand online fast.",
    website: "1-page website or landing page built for quick trust, clear messaging, and fast online presence.",
    cardIncludes: ["1–2 hour shoot", "10–15 professionally edited photos", "1 short promo video", "1-page website / landing page", "Turnaround: 5–7 days"],
    includes: ["1–2 hour shoot", "10–15 professionally edited photos", "1 short promo video (30–45 seconds)", "Clean editing (color, cuts, music)", "1 revision", "1-page website or landing page built for quick trust and clear messaging", "Turnaround: 5–7 days"],
  },
  {
    name: "Silver",
    price: "$1,200",
    deposit: "$450",
    annual: "+ $100/year for website after first year — first year free",
    tagline: "Most Popular — the best balance of quality, content, and growth.",
    description: "This is the go-to option for businesses that want to stand out. You get a full set of content for your website and social media, plus a professional online presence that actually converts.",
    website: "3–5 page custom website with homepage, service/about/contact-style pages, conversion-focused structure, and basic SEO setup.",
    cardIncludes: ["3–4 hour shoot", "25–40 edited photos", "1 cinematic promo video", "2–3 short-form videos", "3–5 page custom website", "Basic SEO setup"],
    includes: ["3–4 hour shoot", "25–40 edited photos", "1 cinematic promo video (60–90 seconds)", "2–3 short-form videos (Reels/TikTok)", "Advanced editing (color grading, sound design)", "2 revisions", "3–5 page custom website with homepage, service/about/contact-style pages", "Basic SEO setup", "Turnaround: 4–6 days"],
  },
  {
    name: "Gold",
    price: "$2,800",
    deposit: "$750",
    annual: "+ $100/year for website after first year — first year free",
    tagline: "The complete, all-in solution for businesses that want to look top-tier and grow fast.",
    description: "Everything comes together in one full content system. Instead of hiring separate people for photos, video, and your website, you get a polished, consistent brand across your website and social media that actually attracts customers.",
    website: "Full custom 5–8+ page website with SEO optimization, performance setup, polished branding, and enough structure for a serious business presence.",
    cardIncludes: ["Full-day shoot", "50+ edited photos", "High-end promo video", "5–8 short-form videos", "Full custom 5–8+ page website", "SEO + performance setup", "Priority delivery"],
    includes: ["Full-day shoot (6–8 hours)", "50+ professionally edited photos", "1 high-end cinematic promo video", "5–8 short-form videos (Reels/TikTok ready)", "Drone footage (if applicable)", "Advanced editing (cinematic color grading, sound design)", "Priority turnaround", "Unlimited revisions (within reason)", "Full custom website (5–8+ pages) with polished branding and serious business structure", "SEO optimization + performance setup", "Content guidance (what to post and how to use everything)", "Turnaround: 2–4 days (priority delivery)", "Professional website that builds trust instantly", "Enough content to stay active on social media for weeks", "High-quality promo video that elevates your brand", "Consistent visuals across everything your customers see"],
  },
];

const presetComparisons = [
  {
    title: "Golden Hour",
    before: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/u4t6ooqq__34A4378.webp",
    after: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/jbkgssxh__34A4378.webp",
  },
  {
    title: "Vintage",
    before: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/r7drg2p5__34A4611.webp",
    after: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/lbi0wanb__34A4611.webp",
  },
  {
    title: "Signature B&W",
    before: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/9lze4uik__34A4786.webp",
    after: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/qi6kknj0__34A4786.webp",
  },
  {
    title: "Color Pop",
    before: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/43v5l6gb__34A4822.webp",
    after: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/5qzl39yz__34A4822.webp",
  },
  {
    title: "Golf",
    before: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/s6zrbkiq__34A6906.webp",
    after: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/trunq2kf__34A6906.webp",
  },
  {
    title: "Grandslam",
    before: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/2oyvvmwp_034A2711.webp",
    after: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/l0b7g8m2_034A2711.webp",
  },
  {
    title: "Soccer",
    before: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/wo3veyti_034A2965.webp",
    after: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/re8bfiz2_034A2965.webp",
  },
  {
    title: "Hockey",
    before: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/cefpz2ly__MGL2361%20%281%29.webp",
    after: "https://customer-assets-0z36b82j.emergentagent.net/job_bold-highlights/artifacts/z43pqzvx__MGL2361.webp",
  },
];

const defaultTimeSlots = [
  "7 AM", "8 AM", "9 AM", "10 AM", "11 AM", "12 PM", "1 PM", "2 PM", "3 PM", "4 PM", "5 PM", "6 PM", "7 PM", "8 PM", "9 PM", "10 PM", "11 PM"
];
const formatDateKey = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const AvailabilityCalendar = ({ availability, selectedDate, selectedSlot, onSelectDate, onSelectSlot, adminMode = false, onToggleSlot }) => {
  const [monthOffset, setMonthOffset] = useState(0);
  const base = new Date();
  const viewDate = new Date(base.getFullYear(), base.getMonth() + monthOffset, 1);
  const firstDay = viewDate.getDay();
  const daysInMonth = new Date(viewDate.getFullYear(), viewDate.getMonth() + 1, 0).getDate();
  const cells = [...Array(firstDay).fill(null), ...Array.from({ length: daysInMonth }, (_, index) => new Date(viewDate.getFullYear(), viewDate.getMonth(), index + 1))];

  return (
    <div className="availability-calendar" data-testid={adminMode ? "admin-availability-calendar" : "availability-calendar"}>
      <div className="calendar-top">
        <button type="button" onClick={() => setMonthOffset((v) => v - 1)} data-testid="calendar-prev-month">‹</button>
        <h3 data-testid="calendar-month-label">{viewDate.toLocaleString('default', { month: 'long', year: 'numeric' })}</h3>
        <button type="button" onClick={() => setMonthOffset((v) => v + 1)} data-testid="calendar-next-month">›</button>
      </div>
      <div className="calendar-grid">
        {['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].map((day) => <span className="calendar-weekday" key={day}>{day}</span>)}
        {cells.map((date, index) => {
          const key = date ? formatDateKey(date) : `blank-${index}`;
          const slots = date ? (availability[key] || []) : [];
          const available = slots.length > 0;
          return <button type="button" disabled={!date || (!available && !adminMode)} className={`calendar-day ${selectedDate === key ? 'selected' : ''} ${available ? 'available' : 'unavailable'}`} key={key} onClick={() => date && onSelectDate?.(key)} data-testid={`calendar-day-${key}`}>{date ? date.getDate() : ''}</button>;
        })}
      </div>
      {selectedDate && (
        <div className="calendar-slots" data-testid="calendar-slots">
          <h4>{selectedDate}</h4>
          {defaultTimeSlots.map((slot) => {
            const active = (availability[selectedDate] || []).includes(slot);
            return <button type="button" key={slot} className={`slot-pill ${active ? 'active' : ''} ${selectedSlot === slot ? 'selected' : ''}`} disabled={!adminMode && !active} onClick={() => adminMode ? onToggleSlot?.(selectedDate, slot) : onSelectSlot?.(slot)} data-testid={`calendar-slot-${slot.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>{slot}</button>;
          })}
        </div>
      )}
    </div>
  );
};

const highlights = [
  realPhotos[0],
  realPhotos[1],
  realPhotos[2],
  realPhotos[3],
  realPhotos[4],
  realPhotos[5],
  realPhotos[6],
  realPhotos[7],
  realPhotos[8],
  realPhotos[9],
  realPhotos[10],
  realPhotos[11],
].map((photo) => ({
  tag: photo.tag,
  title: photo.title,
  image: photo.src,
  href: photoPortfolioUrl,
}));

const PackageCard = ({ item, tone }) => (
  <Link className={`price-card ${tone} package-card-link`} to={`/packages/${item.id}`} data-testid={`${tone}-${item.label.toLowerCase().replace(/\s+/g, "-")}-price-card`}>
    <div className="price-card-top">
      <span data-testid={`${tone}-${item.label.toLowerCase().replace(/\s+/g, "-")}-label`}>{item.label}</span>
      <strong data-testid={`${tone}-${item.label.toLowerCase().replace(/\s+/g, "-")}-price`}>{item.price}</strong>
      {item.meta && <em data-testid={`${tone}-${item.label.toLowerCase().replace(/\s+/g, "-")}-price-meta`}>{item.meta}</em>}
    </div>
    <ul>
      {item.bullets.map((bullet) => (
        <li key={bullet} data-testid={`${tone}-${bullet.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-bullet`}>
          <Check size={18} /> {bullet}
        </li>
      ))}
    </ul>
    <span className="package-learn-more" data-testid={`${tone}-${item.label.toLowerCase().replace(/\s+/g, "-")}-learn-more`}>View Package Details</span>
  </Link>
);

const useSiteViewTracking = () => {
  const location = useLocation();

  useEffect(() => {
    fetch(`${API}/analytics/site-view`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: location.pathname }),
    }).catch((error) => console.error("Site view tracking failed", error));
  }, [location.pathname]);
};

const postBookingToBothBackends = async (payload) => {
  const endpoints = [`${API}/bookings`, `${SAME_SITE_API}/bookings/backup`];
  const results = await Promise.allSettled(
    endpoints.map(async (endpoint) => {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`${endpoint} failed: ${errorText}`);
      }
      const data = await response.json();
      if (!data?.id) throw new Error(`${endpoint} did not return confirmation`);
      return data;
    })
  );
  const successful = results.find((result) => result.status === "fulfilled");
  if (!successful) {
    throw new Error(results.map((result) => result.reason?.message || "Unknown booking error").join(" | "));
  }
  return successful.value;
};

const startBookingCheckout = async (bookingId) => {
  const response = await fetch(`${SAME_SITE_API}/bookings/checkout`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ booking_id: bookingId, origin_url: window.location.origin }),
  });
  if (!response.ok) throw new Error(await response.text());
  const checkout = await response.json();
  window.location.href = checkout.url;
};

const fetchAdminJsonFromBothBackends = async (path, adminCode) => {
  const endpoints = [`${API}${path}`, `${SAME_SITE_API}${path}`];
  const results = await Promise.allSettled(
    endpoints.map(async (endpoint) => {
      const response = await fetch(endpoint, { headers: { "X-Admin-Password": adminCode } });
      if (!response.ok) throw new Error(`${endpoint} failed`);
      return response.json();
    })
  );
  return results.filter((result) => result.status === "fulfilled").map((result) => result.value);
};

const mergeBookings = (bookingLists) => {
  const byKey = new Map();
  bookingLists.flat().forEach((booking) => {
    const key = booking.submission_id || booking.id;
    if (!byKey.has(key)) byKey.set(key, booking);
  });
  return Array.from(byKey.values()).sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
};

const AuthCallback = () => {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace("#", "")).get("session_id");
    const returnPath = sessionStorage.getItem("auth_return_path") || "/book";
    if (!sessionId) {
      navigate(returnPath);
      return;
    }
    fetch(`${SAME_SITE_API}/auth/session`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ session_id: sessionId }),
    })
      .then((response) => {
        if (!response.ok) throw new Error("Auth failed");
        return response.json();
      })
      .then(() => {
        window.history.replaceState(null, "", returnPath);
        navigate(returnPath, { replace: true });
      })
      .catch(() => navigate(returnPath, { replace: true }));
  }, [navigate]);

  return <main className="site-shell"><section className="thank-you-section"><h1>Signing You In...</h1></section></main>;
};

const BookingAuthGate = ({ children, gateId }) => {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    fetch(`${SAME_SITE_API}/auth/me`, { credentials: "include" })
      .then((response) => response.ok ? response.json() : Promise.reject(new Error("Not signed in")))
      .then((data) => setUser(data))
      .catch(() => setUser(null))
      .finally(() => setChecking(false));
  }, []);

  const signIn = () => {
    sessionStorage.setItem("auth_return_path", window.location.pathname + window.location.search);
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (checking) return <div className="auth-gate-card" data-testid={`${gateId}-auth-checking`}>Checking sign-in...</div>;
  if (!user) {
    return (
      <div className="auth-gate-card" data-testid={`${gateId}-auth-required`}>
        <h2>Sign in before booking</h2>
        <p>Use Google to continue. This helps make sure your request is saved under the right contact info.</p>
        <button className="cta-button" onClick={signIn} data-testid={`${gateId}-google-signin-button`}>Sign in with Google</button>
      </div>
    );
  }
  return <>{children}</>;
};

const SiteNav = () => (
  <nav className="top-nav" data-testid="site-navigation">
    <Link className="brand-mark logo-brand" to="/" data-testid="brand-home-link">
      <img src={logoUrl} alt="DiGiuseppi Media logo" data-testid="brand-logo-image" />
    </Link>
    <div className="nav-links" data-testid="navigation-links">
      <a href="/#services" data-testid="nav-services-link">Services</a>
      <a href="/#why-us" data-testid="nav-why-link">Why Us</a>
      <a href="/#portfolio" data-testid="nav-portfolio-link">Highlights</a>
      <a href="/#availability" data-testid="nav-availability-link">Availability</a>
      <a href={instagramUrl} target="_blank" rel="noreferrer" data-testid="nav-instagram-link">Instagram</a>
      <a href={businessCardUrl} target="_blank" rel="noreferrer" data-testid="nav-business-card-link">Card</a>
      <Link to="/book" data-testid="nav-contact-link">Book</Link>
    </div>
  </nav>
);

const SiteFooter = () => (
  <footer className="site-footer" data-testid="site-footer">
    <div className="footer-inner">
      <div className="footer-brand" data-testid="footer-brand">
        <img src={logoUrl} alt="DiGiuseppi Media logo" data-testid="footer-logo" />
        <p data-testid="footer-tagline">Sports media built for athletes, teams & programs across Long Island.</p>
      </div>
      <nav className="footer-links" data-testid="footer-nav">
        <a href="/#services" data-testid="footer-services-link">Services</a>
        <a href="/#why-us" data-testid="footer-why-link">Why Us</a>
        <a href="/#portfolio" data-testid="footer-portfolio-link">Highlights</a>
        <a href="/#availability" data-testid="footer-availability-link">Availability</a>
        <Link to="/book" data-testid="footer-book-link">Book</Link>
        <Link to="/packages/media-day" data-testid="footer-media-day-link">Media Day</Link>
        <Link to="/magazine-package" data-testid="footer-magazine-link">Magazine</Link>
        <Link to="/preset-pack" data-testid="footer-presets-link">Preset Pack</Link>
        <Link to="/business-packages" data-testid="footer-business-link">Business Packages</Link>
      </nav>
      <div className="footer-contact" data-testid="footer-contact">
        <a href="mailto:digiuseppimedia@gmail.com" data-testid="footer-email-link">digiuseppimedia@gmail.com</a>
        <a href={instagramUrl} target="_blank" rel="noreferrer" data-testid="footer-instagram-link">@digiuseppimedia</a>
        <a href={businessCardUrl} target="_blank" rel="noreferrer" data-testid="footer-card-link">Digital Business Card</a>
        <Link to="/admin/bookings" className="admin-footer-link" data-testid="footer-admin-dashboard-link">Admin</Link>
      </div>
    </div>
    <p className="footer-copy" data-testid="footer-copyright">© {new Date().getFullYear()} DiGiuseppi Media. All rights reserved.</p>
  </footer>
);

const PackageDetailPage = () => {
  useSiteViewTracking();
  const { packageId } = useParams();
  const detail = packageDetails[packageId];

  if (!detail) {
    return (
      <main className="site-shell" data-testid="package-not-found-page">
        <div className="noise-layer" />
        <div className="particle-field" />
        <SiteNav />
        <section className="package-detail-page">
          <p className="eyebrow" data-testid="package-not-found-eyebrow">Package not found</p>
          <h1 data-testid="package-not-found-heading">WRONG TURN.</h1>
          <Link className="cta-button" to="/" data-testid="package-not-found-home-link">Back Home</Link>
        </section>
      </main>
    );
  }

  return (
    <main className="site-shell" data-testid={`${detail.id}-detail-page`}>
      <div className="noise-layer" />
      <div className="particle-field" />
      <SiteNav />
      <section className={`package-detail-page ${detail.tone} ${detail.detailClass || ""}`} data-testid={`${detail.id}-detail-section`}>
        <Link className="back-link" to="/#services" data-testid={`${detail.id}-back-to-services-link`}>← Back to services</Link>
        <div className="package-detail-hero">
          <div>
            <p className="eyebrow" data-testid={`${detail.id}-type`}>{detail.type}</p>
            <h1 data-testid={`${detail.id}-headline`}>{detail.headline}</h1>
            <p className="package-detail-description" data-testid={`${detail.id}-description`}>{detail.description}</p>
            <div className="package-detail-price" data-testid={`${detail.id}-price-block`}>
              <strong data-testid={`${detail.id}-price`}>{detail.price}</strong>
              <span data-testid={`${detail.id}-meta`}>{detail.meta}</span>
            </div>
            {detail.terms && <p className="package-detail-terms" data-testid={`${detail.id}-terms`}>{detail.terms}</p>}
            <Link className="cta-button" to={detail.bookingLink || `/book?package=${encodeURIComponent(detail.label)}&type=${encodeURIComponent(detail.type)}`} data-testid={`${detail.id}-book-now-button`}>BOOK NOW</Link>
          </div>
          <div className="package-detail-panel" data-testid={`${detail.id}-deliverables-panel`}>
            <h2 data-testid={`${detail.id}-deliverables-heading`}>WHAT YOU GET</h2>
            <ul>
              {detail.deliverables.map((deliverable) => (
                <li key={deliverable} data-testid={`${detail.id}-${deliverable.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-deliverable`}><Check size={18} /> {deliverable}</li>
              ))}
            </ul>
          </div>
        </div>

        {detail.stats && (
          <div className="package-detail-stats" data-testid={`${detail.id}-stats-row`}>
            {detail.stats.map((stat) => (
              <div className="package-detail-stat" key={stat.label} data-testid={`${detail.id}-stat-${stat.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                <strong>{stat.value}</strong>
                <span>{stat.label}</span>
              </div>
            ))}
          </div>
        )}

        <div className={`package-detail-grid ${!detail.photos && !detail.videos ? "no-media" : ""}`}>
          <div className="package-detail-panel" data-testid={`${detail.id}-ideal-for-panel`}>
            <h2 data-testid={`${detail.id}-ideal-for-heading`}>IDEAL FOR</h2>
            <ul>
              {detail.idealFor.map((item) => (
                <li key={item} data-testid={`${detail.id}-${item.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-ideal-for`}><Check size={18} /> {item}</li>
              ))}
            </ul>
          </div>

          {detail.photos && (
            <div className="package-photo-gallery" data-testid={`${detail.id}-photo-gallery`}>
              {detail.photos.map((photo) => (
                <img src={photo.src} alt={photo.title} key={photo.src} data-testid={`${detail.id}-${photo.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-photo`} />
              ))}
            </div>
          )}

          {detail.videos && (
            <div className="package-video-gallery" data-testid={`${detail.id}-video-gallery`}>
              {detail.videos.map((video, index) => (
                <video src={video} controls playsInline preload="metadata" key={video} data-testid={`${detail.id}-sample-video-${index + 1}`} />
              ))}
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

const initialBookingForm = {
  submission_id: "",
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  sport: "",
  other_sport: "",
  location: "",
  second_location: "",
  session_types: [],
  payment_method: "",
  same_day_turnaround: false,
  preferred_time: "",
  preferred_date: "",
  second_preferred_date: "",
  session_details: "",
  promo_code: "",
  referral_source: "",
  questions: "",
  policy_confirmed: false,
};

const BookingPage = () => {
  useSiteViewTracking();
  const navigate = useNavigate();
  const location = useLocation();
  const selectedPackage = new URLSearchParams(location.search).get("package");
  const selectedType = new URLSearchParams(location.search).get("type");
  const packageSessionMap = {
    "Single Player-Photography": "Single Player Photo $50",
    "Team Package-Photography": "Team Photo (2 Games) $300",
    "Single Player-Videography": "Single Player Video $75",
    "Team Package-Videography": "Team Video (2 Games) $450",
    "Magazine-Magazine": "Sports Magazine Package $110 + Shipping",
  };
  const preselectedSession = packageSessionMap[`${selectedPackage}-${selectedType}`] || "";
  const [form, setForm] = useState(() => ({
    ...initialBookingForm,
    session_types: preselectedSession ? [preselectedSession] : [],
  }));
  const [status, setStatus] = useState("idle");
  const [availability, setAvailability] = useState({});
  const [selectedAvailabilityDate, setSelectedAvailabilityDate] = useState("");

  useEffect(() => {
    fetch(`${SAME_SITE_API}/availability`).then((r) => r.json()).then((days) => {
      setAvailability(Object.fromEntries(days.map((day) => [day.date, day.slots])));
    }).catch(console.error);
  }, []);

  const update = (field, value) => setForm((current) => ({ ...current, [field]: value }));
  const toggleSession = (value) => {
    setForm((current) => ({
      ...current,
      session_types: current.session_types.includes(value)
        ? current.session_types.filter((item) => item !== value)
        : [...current.session_types, value],
    }));
  };

  const submitBooking = async (event) => {
    event.preventDefault();
    setStatus("submitting");
    const submissionId = `booking-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const payload = { ...form, submission_id: submissionId, policy_confirmed: undefined };
    try {
      const savedBooking = await postBookingToBothBackends(payload);
      setStatus("success");
      setForm(initialBookingForm);
      if (form.payment_method === "Credit/Debit/Apple Pay +5% charge") {
        await startBookingCheckout(savedBooking.id);
        return;
      }
      navigate(`/thank-you?booking=${encodeURIComponent(savedBooking.id)}`);
    } catch (error) {
      console.error(error);
      setStatus("error");
    }
  };

  return (
    <main className="site-shell" data-testid="booking-page">
      <div className="noise-layer" />
      <div className="particle-field" />
      <SiteNav />
      <section className="booking-section" data-testid="booking-form-section">
        <div className="booking-heading">
          <p className="eyebrow" data-testid="booking-eyebrow">Book your sports media session</p>
          <h1 data-testid="booking-heading">LOCK IN YOUR SPOT.</h1>
          <p data-testid="booking-subheading">Tell us about your needs and let’s capture the action.</p>
        </div>

        <BookingAuthGate gateId="booking-form">
        <div className="booking-layout">
          <form className="booking-form-card" onSubmit={submitBooking} data-testid="booking-form">
            <div className="form-row two">
              <label data-testid="booking-first-name-label">First Name *<input required value={form.first_name} onChange={(e) => update("first_name", e.target.value)} data-testid="booking-first-name-input" /></label>
              <label data-testid="booking-last-name-label">Last Name *<input required value={form.last_name} onChange={(e) => update("last_name", e.target.value)} data-testid="booking-last-name-input" /></label>
            </div>
            <label data-testid="booking-email-label">Email Address *<input required type="email" placeholder="your.email@example.com" value={form.email} onChange={(e) => update("email", e.target.value)} data-testid="booking-email-input" /></label>
            <label data-testid="booking-phone-label">Phone Number<input placeholder="516-123-4567" value={form.phone} onChange={(e) => update("phone", e.target.value)} data-testid="booking-phone-input" /></label>

            <fieldset data-testid="booking-sport-fieldset">
              <legend>What type of sport or event do you need media for? *</legend>
              {['Baseball', 'Basketball', 'Hockey', 'Football', 'Soccer', 'Track & Field', 'Gymnastics Or Dance', 'Other'].map((sport) => (
                <label className="option-line" key={sport} data-testid={`booking-sport-${sport.toLowerCase().replace(/[^a-z0-9]+/g, '-')}-option`}>
                  <input type="radio" name="sport" required value={sport} checked={form.sport === sport} onChange={(e) => update("sport", e.target.value)} /> {sport === 'Other' ? 'Other (please specify below)' : sport}
                </label>
              ))}
            </fieldset>
            <label data-testid="booking-other-sport-label">If “Other” Sport/Event, please specify:<input placeholder="Tell us more about the sport or event." value={form.other_sport} onChange={(e) => update("other_sport", e.target.value)} data-testid="booking-other-sport-input" /></label>

            <div className="booking-inline-graphic" data-testid="booking-inline-pricing-graphic-panel">
              <img src={pricingGraphic} alt="DiGiuseppi Media pricing packages" data-testid="booking-inline-pricing-graphic" />
            </div>

            <fieldset data-testid="booking-session-type-fieldset">
              <legend>Session Type *</legend>
              {['Single Player Photo $50', 'Team Photo (2 Games) $300', 'Single Player Video $75', 'Team Video (2 Games) $450', 'Sports Magazine Package $110 + Shipping'].map((type) => (
                <label className="option-line" key={type} data-testid={`booking-session-${type.toLowerCase().replace(/[^a-z0-9]+/g, '-')}-option`}>
                  <input type="checkbox" checked={form.session_types.includes(type)} onChange={() => toggleSession(type)} /> {type}
                </label>
              ))}
            </fieldset>

            <fieldset data-testid="booking-payment-method-fieldset">
              <legend>Payment Method *</legend>
              {['Credit/Debit/Apple Pay +5% charge', 'Venmo +5% charge', 'CashApp +5% charge', 'PayPal +5% charge', 'Zelle +5% charge', 'Cash (No Fees)'].map((method) => (
                <label className="option-line" key={method} data-testid={`booking-payment-${method.toLowerCase().replace(/[^a-z0-9]+/g, '-')}-option`}>
                  <input type="radio" name="payment_method" required value={method} checked={form.payment_method === method} onChange={(e) => update("payment_method", e.target.value)} /> {method}
                </label>
              ))}
            </fieldset>
            <label data-testid="booking-location-label">Game / Shoot Location *<input required placeholder="Field, rink, gym, or full address" value={form.location} onChange={(e) => update("location", e.target.value)} data-testid="booking-location-input" /></label>
            <label data-testid="booking-second-location-label">Second Location for Team Packages<input placeholder="Only if second game is at a different location" value={form.second_location} onChange={(e) => update("second_location", e.target.value)} data-testid="booking-second-location-input" /></label>
            <p className="travel-policy-note" data-testid="booking-travel-policy-note">Travel policy: Jobs on Long Island only. No additional charge for Nassau and Suffolk County. Jobs outside Nassau and Suffolk have a $20 up-charge.</p>
            <label className="option-line" data-testid="booking-same-day-label"><input type="checkbox" checked={form.same_day_turnaround} onChange={(e) => update("same_day_turnaround", e.target.checked)} data-testid="booking-same-day-input" /> Same-Day Turnaround +$20</label>
            <label data-testid="booking-time-label">Preferred Session Time (If you chose a team package write Multiple Times) *<input required placeholder="Pick a Time" value={form.preferred_time} onChange={(e) => update("preferred_time", e.target.value)} data-testid="booking-time-input" /></label>
            <label data-testid="booking-date-label">Preferred Session Date *<input required type="date" value={form.preferred_date} onChange={(e) => update("preferred_date", e.target.value)} data-testid="booking-date-input" /></label>
            <AvailabilityCalendar availability={availability} selectedDate={selectedAvailabilityDate || form.preferred_date} selectedSlot={form.preferred_time} onSelectDate={(date) => { setSelectedAvailabilityDate(date); update("preferred_date", date); update("preferred_time", ""); }} onSelectSlot={(slot) => update("preferred_time", slot)} />
            <label data-testid="booking-second-date-label">Second Date for Team Packages<input type="date" value={form.second_preferred_date} onChange={(e) => update("second_preferred_date", e.target.value)} data-testid="booking-second-date-input" /></label>
            <label data-testid="booking-details-label">Session Details & Special Requests *<textarea required placeholder="e.g., I need highlight reels for a basketball tournament on [Date] at [Location]. Focus on scoring shots and team celebrations." value={form.session_details} onChange={(e) => update("session_details", e.target.value)} data-testid="booking-details-input" /></label>
            <label data-testid="booking-promo-label">Promo Code:<input placeholder="Promo codes can usually be found on @digiuseppimedia Instagram" value={form.promo_code} onChange={(e) => update("promo_code", e.target.value)} data-testid="booking-promo-input" /></label>
            <label data-testid="booking-referral-label">How did you hear about me?<textarea placeholder="Type your answer here..." value={form.referral_source} onChange={(e) => update("referral_source", e.target.value)} data-testid="booking-referral-input" /></label>
            <label data-testid="booking-questions-label">Any questions for us?<textarea placeholder="Feel free to ask anything you’d like to know before booking." value={form.questions} onChange={(e) => update("questions", e.target.value)} data-testid="booking-questions-input" /></label>
            <label className="option-line policy-line" data-testid="booking-policy-confirmation-label">
              <input required type="checkbox" checked={form.policy_confirmed} onChange={(e) => update("policy_confirmed", e.target.checked)} data-testid="booking-policy-confirmation-input" />
              I understand jobs are Long Island only and there is no additional charge for Nassau/Suffolk County, but jobs outside Nassau and Suffolk have a $20 up-charge.
            </label>
            <button className="form-submit" type="submit" disabled={status === "submitting"} data-testid="booking-submit-button">{status === "submitting" ? "Submitting..." : "Submit Booking Request"}</button>
            {status === "success" && <p className="form-status success" data-testid="booking-success-message">Booking request sent. Michael will follow up soon.</p>}
            {status === "error" && <p className="form-status error" data-testid="booking-error-message">Something went wrong. Please try again or email digiuseppimedia@gmail.com.</p>}
          </form>

        </div>
        </BookingAuthGate>
      </section>
    </main>
  );
};

const initialMediaDayForm = {
  team_name: "",
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  sport: "",
  other_sport: "",
  athlete_count: 5,
  location: "",
  preferred_date: "",
  preferred_time: "",
  session_details: "",
  terms_confirmed: false,
};

const MediaDayBookingPage = () => {
  useSiteViewTracking();
  const navigate = useNavigate();
  const [form, setForm] = useState(initialMediaDayForm);
  const [status, setStatus] = useState("idle");
  const [availability, setAvailability] = useState({});
  const [selectedAvailabilityDate, setSelectedAvailabilityDate] = useState("");

  useEffect(() => {
    fetch(`${SAME_SITE_API}/availability`).then((r) => r.json()).then((days) => {
      setAvailability(Object.fromEntries(days.map((day) => [day.date, day.slots])));
    }).catch(console.error);
  }, []);

  const update = (field, value) => setForm((current) => ({ ...current, [field]: value }));
  const athleteCount = Math.max(0, parseInt(form.athlete_count, 10) || 0);
  const estimatedTotal = athleteCount * 100;
  const estimatedDeposit = estimatedTotal / 2;
  const belowMinimum = athleteCount < 5;

  const submitMediaDay = async (event) => {
    event.preventDefault();
    if (belowMinimum) {
      setStatus("minimum");
      return;
    }
    setStatus("submitting");
    const submissionId = `booking-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const payload = {
      submission_id: submissionId,
      first_name: form.first_name,
      last_name: form.last_name,
      email: form.email,
      phone: form.phone,
      sport: form.sport,
      other_sport: form.other_sport || undefined,
      location: form.location,
      preferred_time: form.preferred_time,
      preferred_date: form.preferred_date,
      session_details: form.session_details,
      session_types: ["Media Day $100/Athlete (5 Athlete Min)"],
      payment_method: "50% deposit up front, 50% after session",
      team_name: form.team_name,
      athlete_count: athleteCount,
    };
    try {
      const savedBooking = await postBookingToBothBackends(payload);
      setStatus("success");
      navigate(`/thank-you?booking=${encodeURIComponent(savedBooking.id)}`);
    } catch (error) {
      console.error(error);
      setStatus("error");
    }
  };

  return (
    <main className="site-shell" data-testid="media-day-booking-page">
      <div className="noise-layer" />
      <div className="particle-field" />
      <SiteNav />
      <section className="booking-section" data-testid="media-day-booking-section">
        <div className="booking-heading">
          <p className="eyebrow" data-testid="media-day-eyebrow">Team Media Day</p>
          <h1 data-testid="media-day-heading">BOOK YOUR MEDIA DAY.</h1>
          <p data-testid="media-day-subheading">$100 per athlete · 5 athlete minimum · full team session runs about 2.5 hours.</p>
        </div>

        <BookingAuthGate gateId="media-day-booking-form">
        <div className="booking-layout">
          <form className="booking-form-card" onSubmit={submitMediaDay} data-testid="media-day-booking-form">
            <label data-testid="media-day-team-name-label">Team / Organization Name *<input required placeholder="e.g., Long Island Sharks 12U" value={form.team_name} onChange={(e) => update("team_name", e.target.value)} data-testid="media-day-team-name-input" /></label>
            <div className="form-row two">
              <label data-testid="media-day-first-name-label">Contact First Name *<input required value={form.first_name} onChange={(e) => update("first_name", e.target.value)} data-testid="media-day-first-name-input" /></label>
              <label data-testid="media-day-last-name-label">Contact Last Name *<input required value={form.last_name} onChange={(e) => update("last_name", e.target.value)} data-testid="media-day-last-name-input" /></label>
            </div>
            <div className="form-row two">
              <label data-testid="media-day-email-label">Email Address *<input required type="email" placeholder="your.email@example.com" value={form.email} onChange={(e) => update("email", e.target.value)} data-testid="media-day-email-input" /></label>
              <label data-testid="media-day-phone-label">Phone Number<input placeholder="516-123-4567" value={form.phone} onChange={(e) => update("phone", e.target.value)} data-testid="media-day-phone-input" /></label>
            </div>

            <fieldset data-testid="media-day-sport-fieldset">
              <legend>Sport *</legend>
              {['Baseball', 'Basketball', 'Hockey', 'Football', 'Soccer', 'Track & Field', 'Gymnastics Or Dance', 'Other'].map((sport) => (
                <label className="option-line" key={sport} data-testid={`media-day-sport-${sport.toLowerCase().replace(/[^a-z0-9]+/g, '-')}-option`}>
                  <input type="radio" name="media_day_sport" required value={sport} checked={form.sport === sport} onChange={(e) => update("sport", e.target.value)} /> {sport === 'Other' ? 'Other (please specify below)' : sport}
                </label>
              ))}
            </fieldset>
            {form.sport === 'Other' && (
              <label data-testid="media-day-other-sport-label">Please specify:<input value={form.other_sport} onChange={(e) => update("other_sport", e.target.value)} data-testid="media-day-other-sport-input" /></label>
            )}

            <label data-testid="media-day-athlete-count-label">Number of Athletes (5 minimum) *
              <input required type="number" min="5" step="1" value={form.athlete_count} onChange={(e) => update("athlete_count", e.target.value)} data-testid="media-day-athlete-count-input" />
            </label>
            <div className="media-day-estimate" data-testid="media-day-price-estimate">
              <span className="estimate-label">Estimated Total</span>
              <strong data-testid="media-day-estimated-total">{belowMinimum ? "—" : `$${estimatedTotal.toLocaleString()}`}</strong>
              <span className="estimate-note" data-testid="media-day-estimated-deposit">{belowMinimum ? "Enter at least 5 athletes to see your estimate." : `$${estimatedDeposit.toLocaleString()} deposit due up front · $${estimatedDeposit.toLocaleString()} after the session`}</span>
            </div>

            <label data-testid="media-day-location-label">Session Location *<input required placeholder="Field, rink, gym, or full address" value={form.location} onChange={(e) => update("location", e.target.value)} data-testid="media-day-location-input" /></label>
            <label data-testid="media-day-date-label">Preferred Media Day Date *<input required type="date" value={form.preferred_date} onChange={(e) => update("preferred_date", e.target.value)} data-testid="media-day-date-input" /></label>
            <AvailabilityCalendar availability={availability} selectedDate={selectedAvailabilityDate || form.preferred_date} selectedSlot={form.preferred_time} onSelectDate={(date) => { setSelectedAvailabilityDate(date); update("preferred_date", date); update("preferred_time", ""); }} onSelectSlot={(slot) => update("preferred_time", slot)} />
            <label data-testid="media-day-time-label">Preferred Start Time *<input required placeholder="e.g., 5:00 PM — plan for about 2.5 hours" value={form.preferred_time} onChange={(e) => update("preferred_time", e.target.value)} data-testid="media-day-time-input" /></label>
            <label data-testid="media-day-details-label">Anything We Should Know? *<textarea required placeholder="Roster breakdown, uniform colors, specific shots you want, indoor/outdoor, etc." value={form.session_details} onChange={(e) => update("session_details", e.target.value)} data-testid="media-day-details-input" /></label>

            <label className="option-line policy-line" data-testid="media-day-terms-label">
              <input required type="checkbox" checked={form.terms_confirmed} onChange={(e) => update("terms_confirmed", e.target.checked)} data-testid="media-day-terms-checkbox" />
              I understand media day is $100 per athlete (5 athlete minimum), half is due up front as a deposit, and the other half is paid after the session. Proofs are delivered.
            </label>
            <button className="form-submit" type="submit" disabled={status === "submitting" || belowMinimum} data-testid="media-day-submit-button">{status === "submitting" ? "Submitting..." : "Submit Media Day Request"}</button>
            {status === "minimum" && <p className="form-status error" data-testid="media-day-minimum-message">Media day requires a minimum of 5 athletes.</p>}
            {status === "error" && <p className="form-status error" data-testid="media-day-error-message">Something went wrong. Please try again or email digiuseppimedia@gmail.com.</p>}
          </form>
        </div>
        </BookingAuthGate>
      </section>
    </main>
  );
};

const ThankYouPage = () => (
  <ThankYouContent />
);

const PresetThankYouPage = () => {
  const [message, setMessage] = useState("Checking payment and sending your preset pack...");
  const location = useLocation();
  useEffect(() => {
    const sessionId = new URLSearchParams(location.search).get("session_id");
    if (!sessionId) return;
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const response = await fetch(`${SAME_SITE_API}/payments/v1/checkout/status/${sessionId}`);
        const data = await response.json();
        if (data.payment_status === "paid") {
          setMessage("Payment complete. Your preset pack has been emailed to you.");
          return;
        }
      } catch (error) {
        console.error(error);
      }
      if (attempts < 6) setTimeout(poll, 2000);
      else setMessage("Payment is processing. If you do not receive the preset email soon, contact DiGiuseppiMedia.");
    };
    poll();
  }, [location.search]);
  return <main className="site-shell" data-testid="preset-thank-you-page"><div className="noise-layer" /><div className="particle-field" /><SiteNav /><section className="thank-you-section"><p className="eyebrow">Preset Pack</p><h1>THANK YOU</h1><p>{message}</p></section></main>;
};

const ThankYouContent = () => {
  useSiteViewTracking();
  const location = useLocation();
  const bookingId = new URLSearchParams(location.search).get("booking");

  return <main className="site-shell" data-testid="thank-you-page">
    <div className="noise-layer" />
    <div className="particle-field" />
    <SiteNav />
    <section className="thank-you-section" data-testid="thank-you-section">
      <p className="eyebrow" data-testid="thank-you-eyebrow">Request received</p>
      <h1 data-testid="thank-you-heading">YOU’RE LOCKED IN.</h1>
      <p data-testid="thank-you-message">
        Thanks for submitting your booking request. Michael will review the details and follow up soon to confirm availability, package details, and next steps.
      </p>
      {bookingId && <p className="booking-confirmation-id" data-testid="thank-you-booking-id">Confirmation ID: <span data-testid="thank-you-booking-id-value">{bookingId}</span></p>}
      <div className="thank-you-actions" data-testid="thank-you-actions">
        <Link className="cta-button" to="/" data-testid="thank-you-home-link">Back Home</Link>
        <a className="urgency-pill" href={instagramUrl} target="_blank" rel="noreferrer" data-testid="thank-you-instagram-link">Message on Instagram</a>
      </div>
    </section>
  </main>;
};

const CustomPackagePage = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    sport: "",
    other_sport: "",
    location: "",
    photo_count: "10 photos +$25",
    reel_20_count: 0,
    reel_40_count: 0,
    song_name: "",
    song_artist: "",
    graphic_addon: false,
    lockscreen_wallpaper: false,
    micd_up: false,
    budget: "",
    payment_method: "",
    same_day_turnaround: false,
    preferred_time: "",
    preferred_date: "",
    second_preferred_date: "",
    session_details: "",
    policy_confirmed: false,
  });
  const [status, setStatus] = useState("idle");
  const [availability, setAvailability] = useState({});
  const [selectedAvailabilityDate, setSelectedAvailabilityDate] = useState("");
  useSiteViewTracking();

  useEffect(() => {
    fetch(`${SAME_SITE_API}/availability`).then((r) => r.json()).then((days) => setAvailability(Object.fromEntries(days.map((day) => [day.date, day.slots])))).catch(console.error);
  }, []);

  const update = (field, value) => setForm((current) => ({ ...current, [field]: value }));
  const totalReels = Number(form.reel_20_count) + Number(form.reel_40_count);
  const photoPriceMap = {
    "10 photos +$25": 25,
    "20 photos +$40": 40,
    "30 photos +$55": 55,
    "40 photos +$70": 70,
  };
  const customEstimatedTotal =
    (photoPriceMap[form.photo_count] || 0) +
    Number(form.reel_20_count) * 50 +
    Number(form.reel_40_count) * 75 +
    (form.graphic_addon ? 5 : 0) +
    (form.lockscreen_wallpaper ? 5 : 0) +
    (form.micd_up ? 50 : 0) +
    (form.same_day_turnaround ? 20 : 0);
  const submitCustomPackage = async (event) => {
    event.preventDefault();
    setStatus("submitting");
    const submissionId = `custom-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const customDetails = [
      "Custom package is individual only.",
      `Photo add-on: ${form.photo_count}`,
      `20 second hype reels: ${form.reel_20_count} (+$50 each)`,
      `40 second hype reels: ${form.reel_40_count} (+$75 each)`,
      `Song name: ${form.song_name || "Not provided"}`,
      `Artist: ${form.song_artist || "Not provided"}`,
      `Graphic add-on: ${form.graphic_addon ? "Yes (+$5)" : "No"}`,
      `Custom phone lockscreen wallpaper: ${form.lockscreen_wallpaper ? "Yes (+$5)" : "No"}`,
      `Mic'd Up: ${form.micd_up ? "Yes (+$50)" : "No"}`,
      `Same-Day Turnaround: ${form.same_day_turnaround ? "Yes (+$20)" : "No"}`,
      `Package total: $${customEstimatedTotal}`,
      `Budget: ${form.budget || "Not provided"}`,
      `Details: ${form.session_details}`,
    ].join("\n");
    try {
      const payload = {
          submission_id: submissionId,
          first_name: form.first_name,
          last_name: form.last_name,
          email: form.email,
          phone: form.phone,
          sport: form.sport,
          other_sport: form.other_sport,
          location: form.location,
          second_location: "",
          session_types: ["Custom Package"],
          payment_method: form.payment_method,
          same_day_turnaround: form.same_day_turnaround,
          preferred_time: form.preferred_time,
          preferred_date: form.preferred_date,
          second_preferred_date: form.second_preferred_date,
          session_details: customDetails,
          promo_code: "",
          referral_source: "Custom package form",
          questions: "",
        };
      const savedBooking = await postBookingToBothBackends(payload);
      if (form.payment_method === "Credit/Debit/Apple Pay +5% charge") {
        await startBookingCheckout(savedBooking.id);
        return;
      }
      navigate(`/thank-you?booking=${encodeURIComponent(savedBooking.id)}`);
    } catch (error) {
      console.error(error);
      setStatus("error");
    }
  };

  return (
    <main className="site-shell" data-testid="custom-package-page">
      <div className="noise-layer" />
      <div className="particle-field" />
      <SiteNav />
      <section className="booking-section" data-testid="custom-package-form-section">
        <div className="booking-heading">
          <p className="eyebrow" data-testid="custom-package-form-eyebrow">Build your own coverage</p>
          <h1 data-testid="custom-package-form-heading">CUSTOM PACKAGE</h1>
          <p data-testid="custom-package-form-subheading">Combine photo, video, graphics, and extra coverage into one request.</p>
        </div>
        <BookingAuthGate gateId="custom-package-form">
        <form className="booking-form-card" onSubmit={submitCustomPackage} data-testid="custom-package-form">
          <div className="form-row two">
            <label data-testid="custom-first-name-label">First Name *<input required value={form.first_name} onChange={(e) => update("first_name", e.target.value)} data-testid="custom-first-name-input" /></label>
            <label data-testid="custom-last-name-label">Last Name *<input required value={form.last_name} onChange={(e) => update("last_name", e.target.value)} data-testid="custom-last-name-input" /></label>
          </div>
          <label data-testid="custom-email-label">Email Address *<input required type="email" value={form.email} onChange={(e) => update("email", e.target.value)} data-testid="custom-email-input" /></label>
          <label data-testid="custom-phone-label">Phone Number<input value={form.phone} onChange={(e) => update("phone", e.target.value)} data-testid="custom-phone-input" /></label>
          <label data-testid="custom-sport-label">Sport/Event *<input required placeholder="Baseball, hockey, basketball..." value={form.sport} onChange={(e) => update("sport", e.target.value)} data-testid="custom-sport-input" /></label>
          <label data-testid="custom-location-label">Game / Shoot Location *<input required placeholder="Field, rink, gym, or full address" value={form.location} onChange={(e) => update("location", e.target.value)} data-testid="custom-location-input" /></label>
          <p className="travel-policy-note" data-testid="custom-travel-policy-note">Travel policy: Jobs on Long Island only. No additional charge for Nassau and Suffolk County. Jobs outside Nassau and Suffolk have a $20 up-charge.</p>

          <div className="custom-builder" data-testid="custom-builder-section">
            <div className="custom-builder-heading">
              <p className="eyebrow" data-testid="custom-builder-eyebrow">Individual only</p>
              <h2 data-testid="custom-builder-heading">BUILD YOUR PACKAGE</h2>
              <p data-testid="custom-builder-note">Start with 10 photos. Add reels, graphics, and mic’d up coverage as needed. Max 2 reels total.</p>
            </div>
            <fieldset data-testid="custom-photo-count-fieldset">
              <legend>Photo Add-On *</legend>
              {['10 photos +$25', '20 photos +$40', '30 photos +$55', '40 photos +$70'].map((option) => (
                <label className="option-line" key={option} data-testid={`custom-photo-count-${option.toLowerCase().replace(/[^a-z0-9]+/g, '-')}-option`}>
                  <input type="radio" name="custom_photo_count" required value={option} checked={form.photo_count === option} onChange={(e) => update("photo_count", e.target.value)} /> {option}
                </label>
              ))}
            </fieldset>

            <div className="form-row two">
              <label data-testid="custom-reel-20-label">20 Second Hype Reel +$50<select value={form.reel_20_count} onChange={(e) => update("reel_20_count", Number(e.target.value))} data-testid="custom-reel-20-select">
                {[0, 1, 2].filter((count) => count + Number(form.reel_40_count) <= 2).map((count) => <option key={count} value={count}>{count}</option>)}
              </select></label>
              <label data-testid="custom-reel-40-label">40 Second Hype Reel +$75<select value={form.reel_40_count} onChange={(e) => update("reel_40_count", Number(e.target.value))} data-testid="custom-reel-40-select">
                {[0, 1, 2].filter((count) => count + Number(form.reel_20_count) <= 2).map((count) => <option key={count} value={count}>{count}</option>)}
              </select></label>
            </div>

            {totalReels > 0 && (
              <div className="form-row two" data-testid="custom-song-fields">
                <label data-testid="custom-song-name-label">Song Name *<input required value={form.song_name} onChange={(e) => update("song_name", e.target.value)} data-testid="custom-song-name-input" /></label>
                <label data-testid="custom-song-artist-label">Artist *<input required value={form.song_artist} onChange={(e) => update("song_artist", e.target.value)} data-testid="custom-song-artist-input" /></label>
              </div>
            )}

            <label className="option-line" data-testid="custom-graphic-addon-label"><input type="checkbox" checked={form.graphic_addon} onChange={(e) => update("graphic_addon", e.target.checked)} data-testid="custom-graphic-addon-input" /> Graphic +$5</label>
            <label className="option-line" data-testid="custom-lockscreen-wallpaper-label"><input type="checkbox" checked={form.lockscreen_wallpaper} onChange={(e) => update("lockscreen_wallpaper", e.target.checked)} data-testid="custom-lockscreen-wallpaper-input" /> Custom Phone Lockscreen Wallpaper +$5</label>
            <label className="option-line" data-testid="custom-micd-up-label"><input type="checkbox" checked={form.micd_up} onChange={(e) => update("micd_up", e.target.checked)} data-testid="custom-micd-up-input" /> Mic’d Up +$50</label>
            <div className="custom-total" data-testid="custom-package-total">Package total: <strong>${customEstimatedTotal}</strong></div>
          </div>
          <label data-testid="custom-budget-label">Budget / target price range<input placeholder="Optional" value={form.budget} onChange={(e) => update("budget", e.target.value)} data-testid="custom-budget-input" /></label>
          <fieldset data-testid="custom-payment-method-fieldset">
            <legend>Payment Method *</legend>
            {['Credit/Debit/Apple Pay +5% charge', 'Venmo +5% charge', 'CashApp +5% charge', 'PayPal +5% charge', 'Zelle +5% charge', 'Cash (No Fees)'].map((method) => (
              <label className="option-line" key={method} data-testid={`custom-payment-${method.toLowerCase().replace(/[^a-z0-9]+/g, '-')}-option`}>
                <input type="radio" name="custom_payment_method" required value={method} checked={form.payment_method === method} onChange={(e) => update("payment_method", e.target.value)} /> {method}
              </label>
            ))}
          </fieldset>
          <label className="option-line" data-testid="custom-same-day-label"><input type="checkbox" checked={form.same_day_turnaround} onChange={(e) => update("same_day_turnaround", e.target.checked)} data-testid="custom-same-day-input" /> Same-Day Turnaround +$20</label>
          <label data-testid="custom-time-label">Preferred Time *<input required value={form.preferred_time} onChange={(e) => update("preferred_time", e.target.value)} data-testid="custom-time-input" /></label>
          <label data-testid="custom-date-label">Preferred Date *<input required type="date" value={form.preferred_date} onChange={(e) => update("preferred_date", e.target.value)} data-testid="custom-date-input" /></label>
          <AvailabilityCalendar availability={availability} selectedDate={selectedAvailabilityDate || form.preferred_date} selectedSlot={form.preferred_time} onSelectDate={(date) => { setSelectedAvailabilityDate(date); update("preferred_date", date); update("preferred_time", ""); }} onSelectSlot={(slot) => update("preferred_time", slot)} />
          <label data-testid="custom-second-date-label">Second Date if needed<input type="date" value={form.second_preferred_date} onChange={(e) => update("second_preferred_date", e.target.value)} data-testid="custom-second-date-input" /></label>
          <label data-testid="custom-details-label">Anything else we should know? *<textarea required value={form.session_details} onChange={(e) => update("session_details", e.target.value)} data-testid="custom-details-input" /></label>
          <label className="option-line policy-line" data-testid="custom-policy-confirmation-label">
            <input required type="checkbox" checked={form.policy_confirmed} onChange={(e) => update("policy_confirmed", e.target.checked)} data-testid="custom-policy-confirmation-input" />
            I understand jobs are Long Island only and there is no additional charge for Nassau/Suffolk County, but jobs outside Nassau and Suffolk have a $20 up-charge.
          </label>
          <button className="form-submit" type="submit" disabled={status === "submitting"} data-testid="custom-submit-button">{status === "submitting" ? "Submitting..." : "Submit Custom Package Request"}</button>
          {status === "error" && <p className="form-status error" data-testid="custom-error-message">Something went wrong. Please try again.</p>}
        </form>
        </BookingAuthGate>
      </section>
    </main>
  );
};

const MagazinePackagePage = () => {
  useSiteViewTracking();

  return (
    <main className="site-shell" data-testid="magazine-package-page">
      <div className="noise-layer" />
      <div className="particle-field" />
      <SiteNav />
      <section className="magazine-detail-section" data-testid="magazine-detail-section">
        <Link className="back-link" to="/#services" data-testid="magazine-back-link">← Back to services</Link>
        <div className="magazine-hero-block">
          <p className="eyebrow" data-testid="magazine-eyebrow">Premium sports publication</p>
          <h1 data-testid="magazine-heading">CUSTOM SPORTS MAGAZINES</h1>
          <p data-testid="magazine-description">A luxury, print-ready sports magazine designed for athletes, parents, teams, schools, and organizations. Every magazine is built around premium photography, clean storytelling, team colors, and DiGiuseppiMedia branding.</p>
          <div className="magazine-requirement" data-testid="magazine-requirement">Must have bought a Single Player or Team package to purchase a magazine.</div>
          <div className="magazine-price" data-testid="magazine-price">Starting at <strong>$110</strong></div>
          <Link className="cta-button" to="/magazine-order" data-testid="magazine-book-package-button">Order Sports Magazine Package</Link>
        </div>

        <div className="magazine-tier-grid" data-testid="magazine-tier-grid">
          {magazinePackages.map((pkg) => (
            <article className="magazine-tier-card" key={pkg.title} data-testid={`magazine-${pkg.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-card`}>
              <span data-testid={`magazine-${pkg.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-pages`}>{pkg.pages}</span>
              <h2 data-testid={`magazine-${pkg.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-title`}>{pkg.title}</h2>
              <p data-testid={`magazine-${pkg.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-best-for`}>{pkg.bestFor}</p>
              <ul>
                {pkg.includes.map((item) => <li key={item} data-testid={`magazine-${item.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-item`}><Check size={17} /> {item}</li>)}
              </ul>
            </article>
          ))}
        </div>

        <div className="magazine-template-grid" data-testid="magazine-template-grid">
          {magazineTemplateGroups.map((group) => (
            <article className="magazine-template-card" key={group.title} data-testid={`magazine-template-${group.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-card`}>
              <h2 data-testid={`magazine-template-${group.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-title`}>{group.title}</h2>
              <ul>{group.items.map((item) => <li key={item}><Check size={16} /> {item}</li>)}</ul>
            </article>
          ))}
        </div>

        <div className="magazine-specs" data-testid="magazine-approval-note">
          <h2 data-testid="magazine-approval-heading">APPROVAL BEFORE PRINT</h2>
          <p data-testid="magazine-approval-text">Your finished magazine design will be emailed to you for approval before it is printed.</p>
        </div>
      </section>
    </main>
  );
};

const PresetPackPage = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");
  useSiteViewTracking();
  const buyPreset = async (event) => {
    event.preventDefault();
    setStatus("submitting");
    try {
      const response = await fetch(`${SAME_SITE_API}/preset-pack/checkout`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, origin_url: window.location.origin }),
      });
      if (!response.ok) throw new Error(await response.text());
      const checkout = await response.json();
      window.location.href = checkout.url;
    } catch (error) {
      console.error(error);
      setStatus("error");
    }
  };
  return <main className="site-shell" data-testid="preset-pack-page"><div className="noise-layer" /><div className="particle-field" /><SiteNav /><section className="magazine-detail-section"><Link className="back-link" to="/#services">← Back to services</Link><div className="magazine-hero-block"><p className="eyebrow">One Time Offer</p><h1>DIGIUSEPPIMEDIA PRESET PACK</h1><p>Get the same sports-media editing look for your own photos. See all 8 before/after preset examples below.</p><div className="magazine-price">Only <strong>$10</strong></div><form className="preset-order-inline" onSubmit={buyPreset}><label>Email for delivery<input required type="email" value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="your@email.com" /></label><button className="cta-button" type="submit">{status === "submitting" ? "Opening Checkout..." : "Buy Preset Pack"}</button>{status === "error" && <p className="form-status error">Could not start checkout. Try again.</p>}</form></div><div className="preset-comparison-grid" data-testid="preset-comparison-grid">{presetComparisons.map((item)=><article className="preset-comparison-card" key={item.title} data-testid={`preset-comparison-${item.title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}><h2>{item.title}</h2><div className="preset-before-after"><div><span>Before</span><img src={item.before} alt={`${item.title} before`} /></div><div><span>After</span><img src={item.after} alt={`${item.title} after`} /></div></div></article>)}</div></section></main>;
};

const BusinessPackagesPage = () => {
  useSiteViewTracking();
  const navigate = useNavigate();
  const [status, setStatus] = useState("idle");
  const [form, setForm] = useState({ full_name: "", business_name: "", email: "", phone: "", package: "Silver", business_event: "", shoot_description: "", preferred_date: "", shoot_location: "", delivery_timeline: "Standard turnaround", confirmation: false, final_notes: "" });
  const update = (field, value) => setForm((current) => ({ ...current, [field]: value }));
  const submitBusinessPackage = async (event) => {
    event.preventDefault();
    setStatus("submitting");
    const payload = new FormData();
    Object.entries(form).forEach(([key, value]) => payload.append(key, key === "confirmation" ? (value ? "Yes" : "No") : value));
    try {
      const response = await fetch(`${SAME_SITE_API}/business-packages`, { method: "POST", body: payload });
      if (!response.ok) throw new Error(await response.text());
      const order = await response.json();
      const checkoutResponse = await fetch(`${SAME_SITE_API}/business-packages/checkout`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ order_id: order.id, origin_url: window.location.origin }) });
      if (!checkoutResponse.ok) throw new Error(await checkoutResponse.text());
      const checkout = await checkoutResponse.json();
      window.location.href = checkout.url;
    } catch (error) {
      console.error(error);
      setStatus("error");
    }
  };
  return <main className="site-shell" data-testid="business-packages-page"><div className="noise-layer" /><div className="particle-field" /><SiteNav /><section className="booking-section"><div className="booking-heading"><p className="eyebrow">Branding / Business Building</p><h1>BUSINESS PACKAGES</h1><p>Photo, video, and website packages built to help your brand look professional fast.</p></div><div className="business-packages-grid page-grid">{businessPackages.map((pkg)=><article className="business-package-card detailed" key={pkg.name}><span>{pkg.name === "Silver" ? "MOST POPULAR" : pkg.name}</span><h3>{pkg.name} Package</h3><strong>{pkg.price}</strong><em>{pkg.annual}</em><div className="business-card-section"><h4>Summary</h4><p>{pkg.tagline}</p><p>{pkg.description}</p></div><div className="business-card-section website-section"><h4>Website Included</h4><p>{pkg.website}</p></div><div className="business-card-section"><h4>What’s Included</h4><ul>{pkg.includes.map((item)=><li key={item}><Check size={16}/> {item}</li>)}</ul></div><p className="deposit-note"><b>Deposit due today:</b> {pkg.deposit}</p></article>)}</div><form className="booking-form-card" onSubmit={submitBusinessPackage} data-testid="business-package-form"><h2>Contact Info</h2><div className="form-row two"><label>Full Name *<input required value={form.full_name} onChange={(e)=>update('full_name', e.target.value)} /></label><label>Business Name *<input required value={form.business_name} onChange={(e)=>update('business_name', e.target.value)} /></label></div><div className="form-row two"><label>Email Address *<input required type="email" value={form.email} onChange={(e)=>update('email', e.target.value)} /></label><label>Phone Number *<input required value={form.phone} onChange={(e)=>update('phone', e.target.value)} /></label></div><h2>Select Your Package</h2><fieldset>{businessPackages.map((pkg)=><label className="option-line" key={pkg.name}><input type="radio" name="business_package" checked={form.package===pkg.name} onChange={()=>update('package', pkg.name)} /> {pkg.name} — {pkg.price}{pkg.name === "Silver" ? " (Most Popular)" : ""}</label>)}</fieldset><h2>Project Overview</h2><label>What is your business or event? *<input required placeholder="HVAC company, sports team, restaurant..." value={form.business_event} onChange={(e)=>update('business_event', e.target.value)} /></label><label>Brief description of what we’re shooting *<textarea required value={form.shoot_description} onChange={(e)=>update('shoot_description', e.target.value)} /></label><h2>Shoot Details</h2><div className="form-row two"><label>Preferred shoot date *<input required type="date" value={form.preferred_date} onChange={(e)=>update('preferred_date', e.target.value)} /></label><label>Shoot location *<input required value={form.shoot_location} onChange={(e)=>update('shoot_location', e.target.value)} /></label></div><h2>Timeline</h2><fieldset>{["Standard turnaround", "Rush delivery (Bronze +$100, Silver +$200, Gold FREE)"].map((item)=><label className="option-line" key={item}><input type="radio" name="timeline" checked={form.delivery_timeline===item} onChange={()=>update('delivery_timeline', item)} /> {item}</label>)}</fieldset><h2>Confirmation</h2><label className="option-line"><input required type="checkbox" checked={form.confirmation} onChange={(e)=>update('confirmation', e.target.checked)} /> I understand what’s included in my selected package</label><h2>Final Step</h2><label>Anything important I should know before the shoot?<textarea value={form.final_notes} onChange={(e)=>update('final_notes', e.target.value)} /></label><button className="form-submit" type="submit" disabled={status==='submitting'}>{status==='submitting' ? 'Opening Deposit Checkout...' : 'Secure My Spot'}</button>{status==='error' && <p className="form-status error">Something went wrong. Please try again.</p>}</form></section></main>;
};

const MagazineOrderPage = () => {
  useSiteViewTracking();
  const navigate = useNavigate();
  const [status, setStatus] = useState("idle");
  const [form, setForm] = useState({
    name: "", email: "", phone: "", athlete_full_name: "", sport: "", position: "", jersey_number: "", team_name: "", school: "", graduation_year: "",
    magazine_package: "Small (12–16 Pages)", copies_needed: "1", payment_method: "Venmo", cover_style: "Full page action photo", preferred_style: "Match team branding", team_colors: ["#0b1f3a", "#ffffff", "#ff173d", "#168dff"],
    athlete_bio: "", accomplishments: "", favorite_moments: "", favorite_quote: "", season_stats: "", selected_addons: [], athlete_instagram: "", team_instagram: "", other_links: "", event_season: "", final_details: "", files: [],
  });
  const update = (field, value) => setForm((current) => ({ ...current, [field]: value }));
  const updateTeamColor = (index, value) => setForm((current) => {
    const nextColors = [...current.team_colors];
    nextColors[index] = value;
    return { ...current, team_colors: nextColors };
  });
  const toggleAddon = (addon) => setForm((current) => ({ ...current, selected_addons: current.selected_addons.includes(addon) ? current.selected_addons.filter((item) => item !== addon) : [...current.selected_addons, addon] }));
  const magazinePriceMap = { "Small (12–16 Pages)": 110, "Premium (24–32 Pages)": 200, "Team (40+ Pages) — only available for team package": 325 };
  const magazineTotal = (magazinePriceMap[form.magazine_package] || 110) + Math.max(Number(form.copies_needed || 1) - 1, 0) * 30 + form.selected_addons.length * 2;
  const submitMagazineOrder = async (event) => {
    event.preventDefault();
    setStatus("submitting");
    const payload = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      if (key === "files") value.forEach((file) => payload.append("files", file));
      else if (key === "selected_addons") payload.append(key, value.join(", "));
      else if (key === "team_colors") payload.append(key, value.join(", "));
      else payload.append(key, value);
    });
    try {
      const response = await fetch(`${SAME_SITE_API}/magazine-orders`, { method: "POST", body: payload });
      if (!response.ok) throw new Error(await response.text());
      const data = await response.json();
      if (form.payment_method === "Credit/Debit/Apple Pay") {
        const checkoutResponse = await fetch(`${SAME_SITE_API}/magazine-orders/checkout`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ order_id: data.id, origin_url: window.location.origin }),
        });
        if (!checkoutResponse.ok) throw new Error(await checkoutResponse.text());
        const checkout = await checkoutResponse.json();
        window.location.href = checkout.url;
        return;
      }
      navigate(`/thank-you?booking=${encodeURIComponent(data.id)}`);
    } catch (error) {
      console.error(error);
      setStatus("error");
    }
  };
  const addons = ["Senior tribute", "Recruiting page", "Championship page", "Career timeline", "Team page", "Behind-the-scenes page", "Thank you page", "Highlight reel QR code page", "Custom trading card page"];

  return (
    <main className="site-shell" data-testid="magazine-order-page">
      <div className="noise-layer" /><div className="particle-field" /><SiteNav />
      <section className="booking-section" data-testid="magazine-order-section">
        <div className="booking-heading"><p className="eyebrow">Sports Magazine Order</p><h1 data-testid="magazine-order-heading">ORDER SPORTS MAGAZINE PACKAGE</h1><p>Your magazine will be emailed to you for approval before printing.</p></div>
        <BookingAuthGate gateId="magazine-order-form">
        <form className="booking-form-card" onSubmit={submitMagazineOrder} data-testid="magazine-order-form">
          <h2>Customer Information</h2>
          <div className="form-row two"><label>Name *<input required value={form.name} onChange={(e)=>update('name', e.target.value)} data-testid="magazine-name-input" /></label><label>Email *<input required type="email" value={form.email} onChange={(e)=>update('email', e.target.value)} data-testid="magazine-email-input" /></label></div>
          <div className="form-row two"><label>Phone Number *<input required value={form.phone} onChange={(e)=>update('phone', e.target.value)} /></label><label>Athlete Full Name *<input required value={form.athlete_full_name} onChange={(e)=>update('athlete_full_name', e.target.value)} /></label></div>
          <div className="form-row two"><label>Sport *<input required value={form.sport} onChange={(e)=>update('sport', e.target.value)} /></label><label>Position *<input required value={form.position} onChange={(e)=>update('position', e.target.value)} /></label></div>
          <div className="form-row two"><label>Jersey Number *<input required value={form.jersey_number} onChange={(e)=>update('jersey_number', e.target.value)} /></label><label>Team Name *<input required value={form.team_name} onChange={(e)=>update('team_name', e.target.value)} /></label></div>
          <div className="form-row two"><label>School Optional<input value={form.school} onChange={(e)=>update('school', e.target.value)} /></label><label>Graduation Year / Class of *<input required value={form.graduation_year} onChange={(e)=>update('graduation_year', e.target.value)} /></label></div>

          <h2>Magazine Package Selection</h2>
          <fieldset><legend>Choose Package *</legend>{["Small (12–16 Pages)", "Premium (24–32 Pages)", "Team (40+ Pages) — only available for team package"].map((item)=><label className="option-line" key={item}><input type="radio" name="magazine_package" checked={form.magazine_package===item} onChange={()=>update('magazine_package', item)} /> {item} — ${magazinePriceMap[item]} shipping included</label>)}</fieldset>
          <label>Number of copies needed *<input required type="number" min="1" value={form.copies_needed} onChange={(e)=>update('copies_needed', e.target.value)} /></label><p className="travel-policy-note">Digital copy is free with order. Extra print copies are +$30 each. Shipping is included in package pricing.</p>

          <h2>Cover + Style</h2>
          <fieldset><legend>Cover Style *</legend>{["Full page action photo", "Athlete portrait cover", "Magazine-style cover with headlines", "Surprise me / Designer Choice"].map((item)=><label className="option-line" key={item}><input type="radio" name="cover_style" checked={form.cover_style===item} onChange={()=>update('cover_style', item)} /> {item}</label>)}</fieldset>
          <fieldset><legend>Preferred Style *</legend>{["Clean and Modern", "Bold & intense", "Luxury/premium", "Classic Sports Magazine", "Match team branding"].map((item)=><label className="option-line" key={item}><input type="radio" name="preferred_style" checked={form.preferred_style===item} onChange={()=>update('preferred_style', item)} /> {item}{item === "Match team branding" ? " (Popular pick)" : ""}</label>)}</fieldset>
          <div className="magazine-color-grid" data-testid="magazine-team-colors-grid">
            <span>Team colors *</span>
            {form.team_colors.map((color, index) => (
              <label key={`team-color-${index + 1}`} data-testid={`magazine-team-color-${index + 1}-label`}>Color {index + 1}
                <input required type="color" value={color} onChange={(e)=>updateTeamColor(index, e.target.value)} data-testid={`magazine-team-color-${index + 1}-input`} />
              </label>
            ))}
          </div>

          <h2>Story + Highlights</h2>
          <label>Short Athlete Bio *<textarea required value={form.athlete_bio} onChange={(e)=>update('athlete_bio', e.target.value)} placeholder="Where they started, what they enjoy, goals, etc." /></label>
          <label>Biggest Accomplishments *<textarea required value={form.accomplishments} onChange={(e)=>update('accomplishments', e.target.value)} placeholder="Awards, championships, records, milestones..." /></label>
          <label>Favorite Career/Season Moments *<textarea required value={form.favorite_moments} onChange={(e)=>update('favorite_moments', e.target.value)} /></label>
          <label>Favorite Quote or Motto *<input required value={form.favorite_quote} onChange={(e)=>update('favorite_quote', e.target.value)} /></label>

          <h2>Stats + Information</h2><label>Season Stats<textarea value={form.season_stats} onChange={(e)=>update('season_stats', e.target.value)} placeholder="Baseball example: games played, batting average, home runs, RBIs, ERA, OPS. All optional." /></label>
          <h2>Photo Upload</h2><label>Upload team logos or photos<input type="file" multiple accept="image/*" onChange={(e)=>update('files', Array.from(e.target.files || []))} data-testid="magazine-file-input" /></label>
          <h2>Add-ons</h2><fieldset>{addons.map((addon)=><label className="option-line" key={addon}><input type="checkbox" checked={form.selected_addons.includes(addon)} onChange={()=>toggleAddon(addon)} /> {addon} +$2</label>)}</fieldset>
          <h2>Branding</h2><label>Athlete Instagram<input value={form.athlete_instagram} onChange={(e)=>update('athlete_instagram', e.target.value)} /></label><label>Team Instagram<input value={form.team_instagram} onChange={(e)=>update('team_instagram', e.target.value)} /></label><label>Any other links<textarea value={form.other_links} onChange={(e)=>update('other_links', e.target.value)} /></label>
          <h2>Final Details</h2><label>Event/season being featured *<input required value={form.event_season} onChange={(e)=>update('event_season', e.target.value)} placeholder="Ex: 2026 Varsity Baseball season" /></label><label>Anything else I should know?<textarea value={form.final_details} onChange={(e)=>update('final_details', e.target.value)} /></label>
          <h2>Payment Method</h2><fieldset>{["Credit/Debit/Apple Pay", "Venmo", "PayPal", "Zelle", "CashApp"].map((item)=><label className="option-line" key={item}><input type="radio" name="magazine_payment_method" checked={form.payment_method===item} onChange={()=>update('payment_method', item)} /> {item}</label>)}</fieldset>
          <div className="custom-total" data-testid="magazine-order-total">Magazine total: <strong>${magazineTotal}</strong></div>
          <button className="form-submit" type="submit" disabled={status==='submitting'}>{status==='submitting' ? 'Submitting...' : 'Submit Magazine Order'}</button>{status==='error' && <p className="form-status error">Something went wrong. Please try again.</p>}
        </form>
        </BookingAuthGate>
      </section>
    </main>
  );
};

const AdminBookingsPage = () => {
  useSiteViewTracking();
  const [bookings, setBookings] = useState([]);
  const [deletedBookings, setDeletedBookings] = useState([]);
  const [siteViews, setSiteViews] = useState(0);
  const [status, setStatus] = useState("idle");
  const [enteredCode, setEnteredCode] = useState("");
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [bookingSearch, setBookingSearch] = useState("");
  const [adminAvailability, setAdminAvailability] = useState({});
  const [adminPhotoCrops, setAdminPhotoCrops] = useState({});
  const [adminSelectedDate, setAdminSelectedDate] = useState(formatDateKey(new Date()));
  const adminAccessCode = "2469";

  const pressKey = (digit) => {
    if (enteredCode.length >= 4 || status === "loading") return;
    const nextCode = `${enteredCode}${digit}`;
    setEnteredCode(nextCode);
    if (nextCode.length === 4) {
      if (nextCode === adminAccessCode) {
        setIsUnlocked(true);
        loadBookings(null, nextCode);
      } else {
        setStatus("error");
        setTimeout(() => {
          setEnteredCode("");
          setStatus("idle");
        }, 700);
      }
    }
  };

  const clearCode = () => {
    setEnteredCode("");
    setStatus("idle");
  };

  const loadBookings = async (event, overrideCode) => {
    if (event) event.preventDefault();
    setStatus("loading");
    const code = overrideCode || adminAccessCode;
    try {
      const bookingLists = await fetchAdminJsonFromBothBackends("/bookings", code);
      if (bookingLists.length === 0) throw new Error("Invalid password");
      const deletedLists = await fetchAdminJsonFromBothBackends("/bookings/deleted", code);
      const analyticsLists = await fetchAdminJsonFromBothBackends("/analytics/summary", code);
      setBookings(mergeBookings(bookingLists));
      setDeletedBookings(mergeBookings(deletedLists));
      setSiteViews(analyticsLists.reduce((total, item) => total + (item.total_views || 0), 0));
      const availabilityResponse = await fetch(`${SAME_SITE_API}/availability`);
      const availabilityDays = availabilityResponse.ok ? await availabilityResponse.json() : [];
      setAdminAvailability(Object.fromEntries(availabilityDays.map((day) => [day.date, day.slots])));
      const cropsResponse = await fetch(`${SAME_SITE_API}/photo-crops`);
      const cropList = cropsResponse.ok ? await cropsResponse.json() : [];
      setAdminPhotoCrops(Object.fromEntries(cropList.map((crop) => [crop.photo_key, crop.position])));
      setStatus("success");
    } catch (error) {
      console.error(error);
      setStatus("error");
    }
  };

  const deleteBooking = async (bookingId) => {
    const typed = window.prompt("Type DELETE to move this booking to trash.");
    if (typed !== "DELETE") return;
    try {
      const response = await fetch(`${API}/bookings/${bookingId}`, {
        method: "DELETE",
        headers: { "X-Admin-Password": adminAccessCode },
      });
      if (!response.ok) throw new Error("Delete failed");
      const moved = bookings.find((booking) => booking.id === bookingId);
      setBookings((current) => current.filter((booking) => booking.id !== bookingId));
      if (moved) setDeletedBookings((current) => [{ ...moved, deleted: true, deleted_at: new Date().toISOString() }, ...current]);
    } catch (error) {
      console.error(error);
      setStatus("error");
    }
  };

  const saveCrop = async (event, photoKey) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const x = Math.round(((event.clientX - rect.left) / rect.width) * 100);
    const y = Math.round(((event.clientY - rect.top) / rect.height) * 100);
    const position = `${x}% ${y}%`;
    setAdminPhotoCrops((current) => ({ ...current, [photoKey]: position }));
    try {
      await fetch(`${API}/photo-crops`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Admin-Password": adminAccessCode },
        body: JSON.stringify({ photo_key: photoKey, position }),
      });
    } catch (error) {
      console.error(error);
    }
  };

  const resetCrop = async (photoKey) => {
    setAdminPhotoCrops((current) => {
      const next = { ...current };
      delete next[photoKey];
      return next;
    });
    try {
      await fetch(`${API}/photo-crops?photo_key=${encodeURIComponent(photoKey)}`, {
        method: "DELETE",
        headers: { "X-Admin-Password": adminAccessCode },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const restoreBooking = async (bookingId) => {
    try {
      const response = await fetch(`${API}/bookings/${bookingId}/restore`, {
        method: "POST",
        headers: { "X-Admin-Password": adminAccessCode },
      });
      if (!response.ok) throw new Error("Restore failed");
      const restored = deletedBookings.find((booking) => booking.id === bookingId);
      setDeletedBookings((current) => current.filter((booking) => booking.id !== bookingId));
      if (restored) setBookings((current) => [{ ...restored, deleted: false, deleted_at: null }, ...current]);
    } catch (error) {
      console.error(error);
      setStatus("error");
    }
  };

  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
  const analytics = {
    total: bookings.length,
    teamPackages: bookings.filter((booking) => booking.session_types.some((type) => type.toLowerCase().includes("team"))).length,
    photoPackages: bookings.filter((booking) => booking.session_types.some((type) => type.toLowerCase().includes("photo"))).length,
    videoPackages: bookings.filter((booking) => booking.session_types.some((type) => type.toLowerCase().includes("video"))).length,
    baseball: bookings.filter((booking) => booking.sport === "Baseball").length,
    recent7Days: bookings.filter((booking) => new Date(booking.timestamp) >= sevenDaysAgo).length,
    siteViews,
  };
  const visibleBookings = bookingSearch.trim()
    ? bookings.filter((booking) => booking.id.toLowerCase().includes(bookingSearch.trim().toLowerCase()) || booking.email.toLowerCase().includes(bookingSearch.trim().toLowerCase()) || `${booking.first_name} ${booking.last_name}`.toLowerCase().includes(bookingSearch.trim().toLowerCase()) || (booking.team_name || "").toLowerCase().includes(bookingSearch.trim().toLowerCase()))
    : bookings;
  const toggleAvailabilitySlot = async (date, slot) => {
    const currentSlots = adminAvailability[date] || [];
    const nextSlots = currentSlots.includes(slot) ? currentSlots.filter((item) => item !== slot) : [...currentSlots, slot];
    setAdminAvailability((current) => ({ ...current, [date]: nextSlots }));
    await fetch(`${SAME_SITE_API}/availability`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Admin-Password": adminAccessCode },
      body: JSON.stringify({ date, slots: nextSlots }),
    });
  };

  return (
    <main className="site-shell" data-testid="admin-bookings-page">
      <div className="noise-layer" />
      <div className="particle-field" />
      <SiteNav />
      <section className="admin-section" data-testid="admin-bookings-section">
        <p className="eyebrow" data-testid="admin-eyebrow">Private Dashboard</p>
        <h1 data-testid="admin-heading">BOOKING REQUESTS</h1>
        <div className="admin-login-card" data-testid="admin-login-form">
          <p className="admin-password-hint" data-testid="admin-password-hint">Enter 4-digit admin code</p>
          <div className="admin-code-display" data-testid="admin-code-display">{enteredCode.padEnd(4, "•")}</div>
          <div className="admin-keypad" data-testid="admin-keypad">
            {['1','2','3','4','5','6','7','8','9'].map((digit) => (
              <button type="button" key={digit} onClick={() => pressKey(digit)} data-testid={`admin-key-${digit}`}>{digit}</button>
            ))}
            <button type="button" onClick={clearCode} data-testid="admin-key-clear">Clear</button>
            <button type="button" onClick={() => pressKey('0')} data-testid="admin-key-0">0</button>
            <button type="button" onClick={clearCode} data-testid="admin-key-reset">Reset</button>
          </div>
          {status === "error" && <p className="form-status error" data-testid="admin-error-message">Invalid password or unable to load bookings.</p>}
        </div>

        {status === "success" && (
          <>
            <button className="admin-refresh-button" type="button" onClick={() => loadBookings(null, adminAccessCode)} data-testid="admin-load-bookings-button">Refresh Bookings</button>
            <div className="admin-calendar-panel" data-testid="admin-calendar-panel">
              <h2 data-testid="admin-calendar-heading">Availability Calendar</h2>
              <p className="admin-empty">Click a date, then click time slots to mark them available/unavailable.</p>
              <AvailabilityCalendar availability={adminAvailability} selectedDate={adminSelectedDate} onSelectDate={setAdminSelectedDate} adminMode onToggleSlot={toggleAvailabilitySlot} />
            </div>
            <div className="admin-calendar-panel" data-testid="admin-crops-panel">
              <h2 data-testid="admin-crops-heading">Photo Crops</h2>
              <p className="admin-empty">Click on each photo where the athlete or subject is — that spot stays in frame on every screen size (desktop and mobile). Changes apply to the homepage right away. Use Reset to bring back the default crop.</p>
              <div className="admin-crops-grid" data-testid="admin-crops-grid">
                {highlights.map((item) => (
                  <figure className="admin-crop-item" key={item.title} data-testid={`admin-crop-${item.title.toLowerCase().replace(/\s+/g, "-")}`}>
                    <div className="admin-crop-image-wrap" onClick={(event) => saveCrop(event, item.image)} data-testid={`admin-crop-${item.title.toLowerCase().replace(/\s+/g, "-")}-picker`}>
                      <img src={item.image} alt={item.title} style={adminPhotoCrops[item.image] ? { objectPosition: adminPhotoCrops[item.image] } : undefined} />
                      {adminPhotoCrops[item.image] && (
                        <span className="admin-crop-marker" style={{ left: adminPhotoCrops[item.image].split(" ")[0], top: adminPhotoCrops[item.image].split(" ")[1] }} data-testid={`admin-crop-${item.title.toLowerCase().replace(/\s+/g, "-")}-marker`} />
                      )}
                    </div>
                    <figcaption>{item.title}</figcaption>
                    {adminPhotoCrops[item.image] && <button type="button" className="admin-restore-button" onClick={() => resetCrop(item.image)} data-testid={`admin-crop-${item.title.toLowerCase().replace(/\s+/g, "-")}-reset-button`}>Reset Crop</button>}
                  </figure>
                ))}
              </div>
            </div>
            <label className="admin-search-label" data-testid="admin-search-label">Find Booking
              <input value={bookingSearch} onChange={(e) => setBookingSearch(e.target.value)} placeholder="Search name, email, or confirmation ID" data-testid="admin-booking-search-input" />
            </label>
            <div className="admin-analytics-grid" data-testid="admin-analytics-grid">
              <article className="admin-analytics-card" data-testid="admin-analytics-total"><span>Total Requests</span><strong>{analytics.total}</strong></article>
              <article className="admin-analytics-card" data-testid="admin-analytics-site-views"><span>Site Views</span><strong>{analytics.siteViews}</strong></article>
              <article className="admin-analytics-card" data-testid="admin-analytics-recent"><span>Last 7 Days</span><strong>{analytics.recent7Days}</strong></article>
              <article className="admin-analytics-card" data-testid="admin-analytics-photo"><span>Photo Requests</span><strong>{analytics.photoPackages}</strong></article>
              <article className="admin-analytics-card" data-testid="admin-analytics-video"><span>Video Requests</span><strong>{analytics.videoPackages}</strong></article>
              <article className="admin-analytics-card" data-testid="admin-analytics-team"><span>Team Packages</span><strong>{analytics.teamPackages}</strong></article>
              <article className="admin-analytics-card" data-testid="admin-analytics-baseball"><span>Baseball Requests</span><strong>{analytics.baseball}</strong></article>
            </div>
            <div className="admin-bookings-list" data-testid="admin-bookings-list">
              {visibleBookings.length === 0 && <p className="admin-empty" data-testid="admin-empty-message">No bookings found.</p>}
              {visibleBookings.map((booking) => (
                <article className="admin-booking-card" key={booking.id} data-testid={`admin-booking-${booking.id}`}>
                <div className="admin-booking-top">
                  <h2 data-testid={`admin-booking-${booking.id}-name`}>{booking.first_name} {booking.last_name}</h2>
                  <div className="admin-booking-actions">
                    <span data-testid={`admin-booking-${booking.id}-timestamp`}>{new Date(booking.timestamp).toLocaleString()}</span>
                    <button type="button" className="admin-delete-button" onClick={() => deleteBooking(booking.id)} data-testid={`admin-booking-${booking.id}-delete-button`}>Delete</button>
                  </div>
                </div>
                <div className="admin-booking-grid">
                  <p><strong>Email:</strong> <a href={`mailto:${booking.email}`} data-testid={`admin-booking-${booking.id}-email`}>{booking.email}</a></p>
                  <p><strong>Phone:</strong> <a href={`tel:${booking.phone || ""}`} data-testid={`admin-booking-${booking.id}-phone`}>{booking.phone || "Not provided"}</a></p>
                  <p><strong>Sport:</strong> {booking.sport}{booking.other_sport ? ` - ${booking.other_sport}` : ""}</p>
                  {booking.team_name && <p data-testid={`admin-booking-${booking.id}-team`}><strong>Team/Org:</strong> {booking.team_name}</p>}
                  {booking.athlete_count ? <p data-testid={`admin-booking-${booking.id}-athletes`}><strong>Athletes:</strong> {booking.athlete_count}</p> : null}
                  <p><strong>Location:</strong> {booking.location || "Not provided"}</p>
                  <p><strong>Second Location:</strong> {booking.second_location || "Not provided"}</p>
                  <p><strong>Package:</strong> {booking.session_types.join(", ")}</p>
                  <p><strong>Payment:</strong> {booking.payment_method || "Not provided"}</p>
                  <p><strong>Same-Day:</strong> {booking.same_day_turnaround ? "Yes (+$20)" : "No"}</p>
                  <p><strong>Time:</strong> {booking.preferred_time}</p>
                  <p><strong>Date:</strong> {booking.preferred_date}</p>
                  <p><strong>Second Date:</strong> {booking.second_preferred_date || "Not provided"}</p>
                </div>
                <p data-testid={`admin-booking-${booking.id}-details`}><strong>Details:</strong> {booking.session_details}</p>
                <p><strong>Promo:</strong> {booking.promo_code || "None"}</p>
                <p><strong>Referral:</strong> {booking.referral_source || "Not provided"}</p>
                <p><strong>Questions:</strong> {booking.questions || "None"}</p>
                </article>
              ))}
            </div>
            <div className="admin-trash-section" data-testid="admin-trash-section">
              <h2 data-testid="admin-trash-heading">Deleted Bookings</h2>
              {deletedBookings.length === 0 && <p className="admin-empty" data-testid="admin-trash-empty-message">No deleted bookings.</p>}
              <div className="admin-bookings-list">
                {deletedBookings.map((booking) => (
                  <article className="admin-booking-card deleted" key={booking.id} data-testid={`admin-deleted-booking-${booking.id}`}>
                    <div className="admin-booking-top">
                      <h2 data-testid={`admin-deleted-booking-${booking.id}-name`}>{booking.first_name} {booking.last_name}</h2>
                      <div className="admin-booking-actions">
                        <span data-testid={`admin-deleted-booking-${booking.id}-timestamp`}>Deleted: {booking.deleted_at ? new Date(booking.deleted_at).toLocaleString() : "Recently"}</span>
                        <button type="button" className="admin-restore-button" onClick={() => restoreBooking(booking.id)} data-testid={`admin-deleted-booking-${booking.id}-restore-button`}>Restore</button>
                      </div>
                    </div>
                    <div className="admin-booking-grid">
                      <p><strong>Email:</strong> {booking.email}</p>
                      <p><strong>Phone:</strong> {booking.phone || "Not provided"}</p>
                      <p><strong>Sport:</strong> {booking.sport}</p>
                      <p><strong>Location:</strong> {booking.location || "Not provided"}</p>
                      <p><strong>Second Location:</strong> {booking.second_location || "Not provided"}</p>
                      <p><strong>Package:</strong> {booking.session_types.join(", ")}</p>
                      <p><strong>Same-Day:</strong> {booking.same_day_turnaround ? "Yes (+$20)" : "No"}</p>
                    </div>
                    <p><strong>Details:</strong> {booking.session_details}</p>
                  </article>
                ))}
              </div>
            </div>
          </>
        )}
      </section>
    </main>
  );
};

function HomePage() {
  useSiteViewTracking();
  const [selectedGraphic, setSelectedGraphic] = useState(null);
  const videoRefs = useRef([]);
  const [activeSoundVideo, setActiveSoundVideo] = useState(null);
  const [pausedVideos, setPausedVideos] = useState({});
  const [showPresetPopup, setShowPresetPopup] = useState(() => !sessionStorage.getItem("preset_popup_seen"));
  const [presetEmail, setPresetEmail] = useState("");
  const [presetStatus, setPresetStatus] = useState("idle");
  const [publicAvailability, setPublicAvailability] = useState({});
  const [publicSelectedDate, setPublicSelectedDate] = useState("");
  const [photoCrops, setPhotoCrops] = useState({});
  useEffect(() => {
    fetch(`${SAME_SITE_API}/availability`).then((r) => r.json()).then((days) => setPublicAvailability(Object.fromEntries(days.map((day) => [day.date, day.slots])))).catch(console.error);
    fetch(`${SAME_SITE_API}/photo-crops`).then((r) => r.json()).then((crops) => setPhotoCrops(Object.fromEntries(crops.map((crop) => [crop.photo_key, crop.position])))).catch(console.error);
  }, []);
  const closePresetPopup = () => { sessionStorage.setItem("preset_popup_seen", "true"); setShowPresetPopup(false); };
  const buyPresetPack = async (event) => {
    event.preventDefault();
    setPresetStatus("submitting");
    try {
      const response = await fetch(`${SAME_SITE_API}/preset-pack/checkout`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: presetEmail, origin_url: window.location.origin }),
      });
      if (!response.ok) throw new Error(await response.text());
      const checkout = await response.json();
      window.location.href = checkout.url;
    } catch (error) {
      console.error(error);
      setPresetStatus("error");
    }
  };
  const toggleVideoSound = (index) => {
    const target = videoRefs.current[index];
    if (!target) return;
    const turningOff = activeSoundVideo === index;
    videoRefs.current.forEach((video, videoIndex) => {
      if (!video) return;
      if (turningOff) {
        video.muted = true;
        video.play().catch(() => {});
      } else if (videoIndex === index) {
        video.muted = false;
        video.play().catch(() => {});
      } else {
        video.muted = true;
        video.pause();
      }
    });
    setActiveSoundVideo(turningOff ? null : index);
    if (turningOff) setPausedVideos({});
  };
  const toggleVideoPlay = (index) => {
    const target = videoRefs.current[index];
    if (!target) return;
    if (target.paused) {
      target.play().catch(() => {});
      setPausedVideos((current) => ({ ...current, [index]: false }));
    } else {
      target.pause();
      setPausedVideos((current) => ({ ...current, [index]: true }));
      if (activeSoundVideo === index) setActiveSoundVideo(null);
      target.muted = true;
    }
  };

  return (
    <main className="site-shell" data-testid="digiuseppi-media-landing-page">
      <div className="noise-layer" />
      <div className="particle-field" />
      {showPresetPopup && (
        <div className="preset-popup-backdrop" data-testid="preset-popup">
          <form className="preset-popup-card" onSubmit={buyPresetPack} data-testid="preset-popup-form">
            <button type="button" className="preset-popup-close" onClick={closePresetPopup} data-testid="preset-popup-close-button">×</button>
            <p className="eyebrow" data-testid="preset-popup-eyebrow">ONE TIME OFFER</p>
            <h2 data-testid="preset-popup-heading">50% OFF DIGIUSEPPIMEDIA PRESET PACK</h2>
            <strong data-testid="preset-popup-price">ONLY $10</strong>
            <label data-testid="preset-popup-email-label">Email for delivery<input required type="email" value={presetEmail} onChange={(e) => setPresetEmail(e.target.value)} placeholder="your@email.com" data-testid="preset-popup-email-input" /></label>
            <button className="cta-button" type="submit" data-testid="preset-popup-buy-button">{presetStatus === "submitting" ? "Opening Checkout..." : "Buy Now"}</button>
            {presetStatus === "error" && <p className="form-status error">Could not start checkout. Please try again.</p>}
          </form>
        </div>
      )}
      <SiteNav />

      <section id="top" className="hero-section" data-testid="hero-section">
        <div className="hero-copy">
          <p className="eyebrow" data-testid="hero-eyebrow">SPORTS MEDIA, EVENT COVERAGE, PROMOTIONAL VIDEOS + WEBSITE BUILDING</p>
          <h1 className="hero-title" data-testid="hero-headline">DIGIUSEPPI<br />MEDIA</h1>
          <p className="hero-subheadline" data-testid="hero-subheadline">SPORTS MEDIA BUILT FOR ATHLETES, TEAMS & PROGRAMS</p>
          <p className="hero-support" data-testid="hero-support-line">Professional photos, videos and graphics with fast turnaround across Long Island.</p>
          <div className="hero-actions">
            <Link className="cta-button" to="/book" data-testid="hero-book-now-button">BOOK NOW</Link>
            <span className="urgency-pill" data-testid="hero-urgency-text"><Zap size={16} /> Limited Spots Each Week</span>
          </div>
        </div>
        <div className="hero-poster" data-testid="hero-sports-poster">
          <img src={heroImage} alt="Dramatic football athlete in smoke" data-testid="hero-athlete-image" />
        </div>
      </section>

      <section id="services" className="section-block" data-testid="services-section">
        <div className="section-heading">
          <h2 data-testid="services-heading">SPORTS PACKAGES</h2>
        </div>

        <div className="services-grid">
          <div className="service-panel red-panel" data-testid="photography-service-panel">
            <img className="panel-athlete" src={photoAthlete} alt="Athlete in dramatic smoke" data-testid="photography-athlete-image" />
            <div className="service-header">
              <Camera size={34} />
              <h3 data-testid="photography-title">Photography</h3>
            </div>
            <p data-testid="photography-description">Clean edits, dramatic lighting, and images that make every athlete look recruit-ready.</p>
            <div className="card-stack">
              {photoPackages.map((item) => <PackageCard key={item.label} item={item} tone="photo" />)}
            </div>
          </div>

          <div className="service-panel blue-panel" data-testid="videography-service-panel">
            <img className="panel-athlete right" src={videoAthlete} alt="Football athlete under stadium lights" data-testid="videography-athlete-image" />
            <div className="service-header">
              <Video size={34} />
              <h3 data-testid="videography-title">Videography</h3>
            </div>
            <p data-testid="videography-description">Aggressive pacing, cinematic sound, and reels engineered for attention.</p>
            <div className="card-stack">
              {videoPackages.map((item) => <PackageCard key={item.label} item={item} tone="video" />)}
            </div>
          </div>
        </div>

        <p className="package-help-note" data-testid="package-help-note">Not sure which package is right for you? <a href="#contact" data-testid="package-help-contact-link">Contact me</a> and I’ll help you choose.</p>

        <div className="custom-package-panel" data-testid="custom-package-panel">
          <div>
            <p className="eyebrow" data-testid="custom-package-eyebrow">Need something different?</p>
            <h3 data-testid="custom-package-heading">BUILD A CUSTOM PACKAGE</h3>
            <p data-testid="custom-package-description">Combine photo, video, graphics, extra games, or team coverage into one custom request. Perfect if you want both photos and video or need coverage that does not fit the standard packages.</p>
          </div>
          <div className="custom-package-actions">
            <Link className="cta-button" to="/custom-package" data-testid="custom-package-book-now-button">Build My Package</Link>
            <span data-testid="custom-package-note">Select multiple session types on the booking form.</span>
          </div>
        </div>

        <div className="magazine-package-panel" data-testid="media-day-package-panel">
          <div>
            <p className="eyebrow" data-testid="media-day-package-eyebrow">Full team photo session</p>
            <h3 data-testid="media-day-package-heading">MEDIA DAY</h3>
            <p data-testid="media-day-package-description">One session, about 2.5 hours, and every athlete walks away with 8–10 edited photos — 2 headshots plus 6–8 action/body shots. Proofs are delivered for your team to review.</p>
          </div>
          <div className="custom-package-actions">
            <Link className="cta-button" to="/packages/media-day" data-testid="media-day-package-learn-more-button">View Media Day Package</Link>
            <span data-testid="media-day-package-note">$100 per athlete · 5 athlete minimum</span>
          </div>
        </div>

        <div className="magazine-package-panel" data-testid="magazine-package-panel">
          <div>
            <p className="eyebrow" data-testid="magazine-package-eyebrow">Premium print product</p>
            <h3 data-testid="magazine-package-heading">SPORTS MAGAZINE PACKAGE</h3>
            <p data-testid="magazine-package-description">A customizable athlete or team magazine product for families, teams, schools, and organizations. Must have purchased a single player or team package to order.</p>
          </div>
          <div className="custom-package-actions">
            <Link className="cta-button" to="/magazine-package" data-testid="magazine-package-learn-more-button">View Magazine Package</Link>
            <span data-testid="magazine-package-note">Starting at $110</span>
          </div>
        </div>

        <div className="preset-pack-panel" data-testid="preset-pack-panel">
          <div>
            <p className="eyebrow" data-testid="preset-pack-eyebrow">Editing tools</p>
            <h3 data-testid="preset-pack-heading">DiGiuseppi Media Sports Preset Pack</h3>
            <p data-testid="preset-pack-description">A downloadable preset pack for sports edits. Before and after examples will be added soon.</p>
          </div>
          <div className="custom-package-actions">
            <Link className="cta-button" to="/preset-pack" data-testid="preset-pack-learn-more-button">View Preset Pack</Link>
            <span data-testid="preset-pack-note">Only $10</span>
          </div>
        </div>

        <div className="business-building-heading" data-testid="business-building-heading">
          <h2>BRANDING/BUSINESS BUILDING</h2>
        </div>
        <div className="business-packages-grid" data-testid="business-packages-grid">
          {businessPackages.map((pkg) => (
            <article className="business-package-card" key={pkg.name} data-testid={`business-package-${pkg.name.toLowerCase()}-card`}>
              <span>{pkg.name === "Silver" ? "MOST POPULAR" : pkg.name}</span>
              <h3>{pkg.name} Package</h3>
              <strong>{pkg.price}</strong>
              <em>{pkg.annual}</em>
              <p>{pkg.tagline}</p>
              <p>{pkg.description}</p>
              <ul>{pkg.cardIncludes.map((item) => <li key={item}><Check size={16} /> {item}</li>)}</ul>
            </article>
          ))}
        </div>
        <Link className="cta-button business-package-cta" to="/business-packages" data-testid="business-packages-book-link">Book My Package</Link>
        <div className="previous-websites" data-testid="previous-websites-section">
          <p className="eyebrow" data-testid="previous-websites-eyebrow">Previous Websites</p>
          <a href="https://anronac.com" target="_blank" rel="noreferrer" data-testid="previous-website-anronac-link">anronac.com</a>
          <a href="https://digiuseppimedia.com" target="_blank" rel="noreferrer" data-testid="previous-website-digiuseppimedia-link">digiuseppimedia.com</a>
        </div>

      </section>

      <section id="portfolio" className="section-block portfolio-section" data-testid="portfolio-section">
        <div className="section-heading row-heading">
          <div>
            <p className="eyebrow" data-testid="portfolio-eyebrow">Portfolio</p>
            <h2 data-testid="portfolio-heading">SEE THE WORK.</h2>
          </div>
          <div className="portfolio-actions" data-testid="portfolio-action-links">
            <a href={mediaPortfolioUrl} target="_blank" rel="noreferrer" className="coming-soon" data-testid="video-portfolio-link">View Video Work</a>
            <a href={mediaPortfolioUrl} target="_blank" rel="noreferrer" className="coming-soon blue" data-testid="media-portfolio-link">View Media Portfolio</a>
          </div>
        </div>
        <div className="portfolio-mini-grid" data-testid="portfolio-mini-grid">
          {highlights.map((item) => (
            <a className="portfolio-mini-card" href={item.href} target="_blank" rel="noreferrer" key={item.title} data-testid={`portfolio-preview-${item.title.toLowerCase().replace(/\s+/g, "-")}-card`}>
              <img src={item.image} alt={item.title} style={photoCrops[item.image] ? { objectPosition: photoCrops[item.image] } : undefined} data-testid={`portfolio-preview-${item.title.toLowerCase().replace(/\s+/g, "-")}-image`} />
              <span data-testid={`portfolio-preview-${item.title.toLowerCase().replace(/\s+/g, "-")}-label`}>{item.tag}</span>
            </a>
          ))}
        </div>
        <div className="section-heading row-heading video-section-heading">
          <div>
            <p className="eyebrow" data-testid="video-highlights-eyebrow">Highlight Videos</p>
            <h2 data-testid="video-highlights-heading">WATCH THE ACTION.</h2>
          </div>
        </div>
        <div className="video-highlights-grid" data-testid="video-highlights-grid">
          {videoHighlights.map((video, index) => (
            <article className="video-highlight-card" key={video.title} data-testid={`video-highlight-${video.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-card`}>
              <div className="video-frame">
                <video ref={(element) => { videoRefs.current[index] = element; }} src={video.src} autoPlay muted loop playsInline preload="auto" data-testid={`video-highlight-${video.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-video`} />
                <div className="video-overlay-controls" data-testid={`video-highlight-${video.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-controls`}>
                  <button type="button" onClick={() => toggleVideoPlay(index)} data-testid={`video-highlight-${index + 1}-play-button`}>{pausedVideos[index] ? "▶" : "Ⅱ"}</button>
                  <button type="button" onClick={() => toggleVideoSound(index)} data-testid={`video-highlight-${index + 1}-mute-button`}>{activeSoundVideo === index ? "🔊" : "🔇"}</button>
                </div>
              </div>
              <p className="video-caption" data-testid={`video-highlight-${video.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-caption`}>{video.caption}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="about-section" data-testid="about-section">
        <div className="about-story-card" data-testid="about-story-card">
          <p className="eyebrow" data-testid="about-eyebrow">Behind the Lens</p>
          <h2 data-testid="about-heading">MEET MICHAEL</h2>
          <div className="about-story-copy" data-testid="about-description">
            <p>
              Hi, my name is Michael, and I’m a 13-year-old sports photographer based on Long Island. Ever since I picked up a camera, I’ve been drawn to the energy, intensity, and emotion of sports. I love being right in the middle of the action, capturing moments that most people don’t even notice—whether it’s the decisive game-winning play, a subtle look of determination, or a quiet moment of reflection on the sideline. For me, sports photography isn’t just about taking pictures; it’s about telling the story of the game, showing the effort, passion, and teamwork that go into every play.
            </p>
            <p>
              I approach every event with the goal of capturing both the feeling and the action. I care just as much about how a photo makes someone feel as I do about how it looks. Each image I take is meant to freeze a memory in time, something that athletes, teams, and families can look back on and feel proud of years later. I’m always learning, experimenting, and finding new ways to bring a game to life through my lens, because for me, photography is about more than just pictures—it’s about capturing the heart of the game.
            </p>
          </div>
        </div>
      </section>

      <section className="graphics-section" data-testid="graphics-section">
        <div className="section-heading row-heading">
          <div>
            <p className="eyebrow" data-testid="graphics-eyebrow">Custom Edits</p>
            <h2 data-testid="graphics-heading">GRAPHICS THAT HIT HARD.</h2>
          </div>
          <p className="graphics-note" data-testid="graphics-note">Poster-style edits built for athletes, teams, and social media drops.</p>
        </div>
        <div className="graphics-grid" data-testid="graphics-grid">
          {graphicShowcase.map((graphic) => (
            <button className="graphic-card" type="button" onClick={() => setSelectedGraphic(graphic)} key={graphic.title} data-testid={`graphic-${graphic.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-card`}>
              <img src={graphic.src} alt={graphic.title} data-testid={`graphic-${graphic.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-image`} />
            </button>
          ))}
        </div>
        {selectedGraphic && (
          <div className="graphic-lightbox" onClick={() => setSelectedGraphic(null)} data-testid="graphic-lightbox">
            <button className="graphic-lightbox-close" type="button" onClick={() => setSelectedGraphic(null)} data-testid="graphic-lightbox-close-button">Close</button>
            <img src={selectedGraphic.src} alt={selectedGraphic.title} onClick={(event) => event.stopPropagation()} data-testid="graphic-lightbox-image" />
          </div>
        )}
      </section>

      <div id="why-us" className="why-wrap" data-testid="why-us-section">
        <div className="section-heading">
          <p className="eyebrow" data-testid="why-us-eyebrow">The Difference</p>
          <h2 data-testid="why-us-heading">WHY DIGIUSEPPI MEDIA?</h2>
        </div>
      <section className="features-bar relocated" aria-label="Core features" data-testid="features-bar">
        {features.map(({ icon: Icon, title, detail }) => (
          <div className="feature-item" key={title} data-testid={`feature-${title.toLowerCase().replace(/\s+/g, "-")}`}>
            <Icon size={25} />
            <div>
              <strong data-testid={`feature-${title.toLowerCase().replace(/\s+/g, "-")}-title`}>{title}</strong>
              <span data-testid={`feature-${title.toLowerCase().replace(/\s+/g, "-")}-detail`}>{detail}</span>
            </div>
          </div>
        ))}
      </section>
      </div>

      <section className="faq-section" data-testid="faq-section">
        <div className="section-heading row-heading">
          <div>
            <p className="eyebrow" data-testid="faq-eyebrow">Questions before you book?</p>
            <h2 data-testid="faq-heading">FAQ</h2>
          </div>
          <Link className="cta-button compact" to="/book" data-testid="faq-book-now-button">BOOK NOW</Link>
        </div>
        <div className="faq-grid" data-testid="faq-grid">
          {faqs.map((faq, index) => (
            <details className="faq-item" key={faq.question} data-testid={`faq-item-${index + 1}`}>
              <summary data-testid={`faq-question-${index + 1}`}>{faq.question}</summary>
              <p data-testid={`faq-answer-${index + 1}`}>{faq.answer}</p>
            </details>
          ))}
        </div>
      </section>

      <section id="contact" className="contact-section" data-testid="contact-section">
        <div className="contact-copy">
          <p className="eyebrow" data-testid="contact-eyebrow">Ready this week?</p>
          <h2 data-testid="contact-heading">BOOK THE SHOOT BEFORE THE SPOT IS GONE.</h2>
          <p data-testid="contact-description">Send the form, drop your sport, date, and package type — then get locked in.</p>
          <Link className="cta-button wide" to="/book" data-testid="contact-book-now-button">BOOK NOW</Link>
        </div>
        <form className="contact-card" onSubmit={(e) => { e.preventDefault(); window.location.href = '/book'; }} data-testid="contact-form">
          <label data-testid="contact-name-label">Name<input data-testid="contact-name-input" placeholder="Athlete name" /></label>
          <label data-testid="contact-sport-label">Sport<input data-testid="contact-sport-input" placeholder="Football, basketball, soccer..." /></label>
          <label data-testid="contact-message-label">What do you need?<textarea data-testid="contact-message-input" placeholder="Single player photos, team video, media day..." /></label>
          <button type="submit" className="form-submit" data-testid="contact-form-submit-button">Open Booking Form</button>
          <a className="instagram-link" href={instagramUrl} target="_blank" rel="noreferrer" data-testid="instagram-profile-link"><Instagram size={18} /> @digiuseppimedia</a>
          <a className="instagram-link" href={businessCardUrl} target="_blank" rel="noreferrer" data-testid="business-card-link">Virtual Business Card</a>
          <a className="instagram-link email-link" href="mailto:digiuseppimedia@gmail.com" data-testid="contact-email-link">digiuseppimedia@gmail.com</a>
          <a className="instagram-link phone-link" href="tel:5166157040" data-testid="contact-phone-link">516-615-7040</a>
        </form>
      </section>

      <section id="availability" className="section-block availability-section" data-testid="public-availability-section">
        <div className="section-heading">
          <p className="eyebrow" data-testid="availability-eyebrow">Availability</p>
          <h2 data-testid="availability-heading">CHECK OPEN DATES.</h2>
        </div>
        <AvailabilityCalendar availability={publicAvailability} selectedDate={publicSelectedDate} onSelectDate={setPublicSelectedDate} />
      </section>
    </main>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/book" element={<BookingPage />} />
      <Route path="/media-day-booking" element={<MediaDayBookingPage />} />
      <Route path="/custom-package" element={<CustomPackagePage />} />
      <Route path="/magazine-package" element={<MagazinePackagePage />} />
      <Route path="/preset-pack" element={<PresetPackPage />} />
      <Route path="/business-packages" element={<BusinessPackagesPage />} />
      <Route path="/magazine-order" element={<MagazineOrderPage />} />
      <Route path="/thank-you" element={<ThankYouPage />} />
      <Route path="/preset-thank-you" element={<PresetThankYouPage />} />
      <Route path="/admin/bookings" element={<AdminBookingsPage />} />
      <Route path="/packages/:packageId" element={<PackageDetailPage />} />
      </Routes>
      <SiteFooter />
    </>
  );
}

export default App;